var tooltipCache={};
var prev_bs;
var filter_array=[];
var effects_filter_array=[];
var gear_effects_filter_array=[];
var favorites=[];
var fav_loaded=false;
var sk={};
var sck={};
var kq=[];
var curtaint_pending=false;
// var quests_array = {};
var titles_array=[];
var prev_sq='';
var search_results=[];
var dropdown_items=[];
var dropdown_idx=- 1;

$(document).ready(function ()
{
    //Comments
    $('#comment_text').markItUp(mySettings);
    $('#emoticons a').click(function ()
    {
        emoticon=$(this).attr("title");
        $.markItUp({replaceWith: emoticon});
        return false;
    });
    linktip();

    // $('#main-menu').on('beforeshow.smapi', function (e, item)
    // {
    //     if ($(item).attr('aria-labelledby') == 'DatabaseDropdown')
    //     {
    //         if (!$('#main-menu').hasClass('sm-collapsible'))
    //         {
    //             // $('.curtain').css('display', 'block');
    //             $('#adtag_top').addClass('curtain_new');
    //             curtaint_pending = false;
    //         }
    //     }
    // }).on('hideAll.smapi', function (e, item)
    // {
    //     if (!$('#main-menu').hasClass('sm-collapsible'))
    //     {
    //         curtaint_pending = true;
    //         delay(function ()
    //         {
    //             if (curtaint_pending)
    //             {
    //                 // $('.curtain').css('display', 'none');
    //                 $('#adtag_top').removeClass('curtain_new');
    //             }
    //         }, 3000);
    //     }
    // });


    $("#dialoglink").click(function ()
    {
        $("#loginblock").dialog({
            dialogClass: "login", height: 190, width: 270, modal: true
        });
    });

    $('#subscribe_button').click(function ()
    {
        process_subscription(this);
    });
    $('#unsub_all_button').click(function ()
    {
        unsubscribe_all(this);
    });

    $('.save_settings_button').click(function ()
    {
        save_user_settings();
    });

    $('.user_filter').click(function ()
    {
        save_ui_settings(this);
    });

    $(".selectall").on("click", function ()
    {
        $(this).select();
    });
    $("#show_3d_viewer").on("click", function ()
    {
        $("#3d_viewer_frame").toggleClass("viewer_frame");
        $("#canvas").toggleClass("hide_me");
        $(this).hide();
        start_viewer();
    });

    const clear_action=get_action();
    if (clear_action === 'recipe' || clear_action === 'mrecipe' || clear_action === 'design')
    {
        get_recipe_hash();
        set_recipe_hash_handler();
        set_recipe_handler();
        set_price_button_handlers();
        get_real_material_prices(false);
        $('#price_region').change(function ()
        {
            update_real_material_prices(true);
        });
    }


    //$(".toggle-image").click(function ()
    //	{
    //		console.log('here');
    //		$(this).siblings(".content").toggle();
    //		$(this).toggleClass("toggle-open");
    //		return false;
    //	}
    //);

    $(".toggle_text").click(function ()
    {
        $("#"+$(this).data("target_id")).toggle();
    });

    $('.qtooltip').each(function ()
    {
        $(this).qtip(qtip_options());
    });


    get_title_statuses();
    // $('.title_fav_checkbox').each(function ()
    // {
    //     set_title_status(this);
    //     $(this).on("click", function ()
    //     {
    //         save_title_status(this);
    //     });
    // });

    $(".copy").on("click", function ()
    {
        // clipboard.copy($("#" + $(this).data("cid")).val());
        copy_to_clipboard($('#'+$(this).data('cid')).val());
    });


    // add_search_handler();


    var source=new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/ac.php?l='+lang+'&term=%QUERY', wildcard: '%QUERY'
        },
        limit: Infinity
    });

    source.initialize();

    $('.typeahead').typeahead(
        {
            hint: true, highlight: true, minLength: 2
        },
        {
            name: 'matched-links', displayKey: 'name', limit: Infinity, source: source.ttAdapter(),
            templates:
                {
                    empty: null, //suggestion: Handlebars.compile('<p><a href="{{link}}" class="qtooltip" data-id="{{link_type}}--{{value}}"{{link_addon}}><img src="/{{icon_path}}/{{icon}}" class="image-text" alt="icon" width="30px" height="30px"> <span class="item_grade_{{grade}}">{{name}}</span><span class="object_type">{{object_type}}</span></a></p>')
                    suggestion: Handlebars.compile('<div class="qtooltip" data-id="{{link_type}}--{{value}}" data-quest_group="{{quest_group}}"><div class="search_icon me-1"><img src="/{{icon_path}}/{{icon}}" class="image-text grade_frame_{{grade}}" alt="icon" width="35px" height="35px">{{{subicon}}}</div> <span class="item_grade_{{grade}}">{{name}}</span><span class="object_type">{{object_type}}</span></div>')
                }
        });


    /*
    To disable the suggestion fill in change:
    comment "this.input.setQuery(data.val, true);"
    in "select: function select($selectable)"

    * */

    $('.typeahead').bind('typeahead:render', function (ev, suggestion, flag, dataset_name)
    {
        $('.qtooltip.tt-suggestion').each(function ()
        {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            {
            }
            else
            {
                $(this).qtip(qtip_options());
            }
        });
    });
    $(".typeahead").on("typeahead:selected", function (e, datum)
    {
        //if (blank != "")
        //{
        //	window.open(datum.link)
        //}
        //else window.location.href = datum.link;
        //console.log('here');
        window.open(datum.link);
        //window.location.href = datum.link;
    });
    $('.typeahead').on('keydown', function (e)
    {
        if (e.keyCode == 13)
            document.querySelector('[role="search"]').submit();
    });
//    $('#sidebar').affix({
//        offset: {
//            top: 50
//        }
//    });

    $('.toggler').click(function ()
    {
        $('#'+$(this).data('group_id')).toggle();
        $(this).children('.plus_minus').toggleClass('toggle-open');
    });


    $('.enh_plus').on("click", function ()
    {
        var ce_value=$("#cen_value").html();
        var e_value=$("#en_value").html();
        var max_enchant=$("#en_value").data("maxenchant");
        if (e_value < max_enchant)
        {
            e_value ++;
            if (e_value >= 18)
            {
                $('.cenh_minus, .cenh_plus').prop('disabled', false);
            }
            $("#en_value").html(e_value);
            var enchantment="+"+e_value+': ';
            if (e_value == 16) enchantment=pri;
            else if (e_value == 17) enchantment=duo;
            else if (e_value == 18) enchantment=tri;
            else if (e_value == 19) enchantment=tet;
            else if (e_value == 20) enchantment=pen;
            else if (e_value == 21) enchantment=hex;
            else if (e_value == 22) enchantment=sep;
            else if (e_value == 23) enchantment=oct;
            else if (e_value == 24) enchantment=nov;
            else if (e_value == 25) enchantment=dec;
            $("#enchantment_value").html(enchantment+" ");
            set_stats(e_value);
            set_cstats();
            update_hash(e_value, ce_value);
            if (typeof real_item_prices !== 'undefined' && typeof real_item_prices['prices'] !== 'undefined') print_real_price(real_item_prices['prices']);
        }
    });
    $('.enh_max').on("click", function ()
    {
        var ce_value=$("#cen_value").html();
        var e_value=$("#en_value").html();
        var max_enchant=$("#en_value").data("maxenchant");
        if (e_value < max_enchant)
        {
            e_value=max_enchant;
            if (e_value >= 18)
            {
                $('.cenh_minus, .cenh_plus').prop('disabled', false);
            }
            $("#en_value").html(e_value);
            var enchantment="+"+e_value+': ';
            if (e_value == 16) enchantment=pri;
            else if (e_value == 17) enchantment=duo;
            else if (e_value == 18) enchantment=tri;
            else if (e_value == 19) enchantment=tet;
            else if (e_value == 20) enchantment=pen;
            else if (e_value == 21) enchantment=hex;
            else if (e_value == 22) enchantment=sep;
            else if (e_value == 23) enchantment=oct;
            else if (e_value == 24) enchantment=nov;
            else if (e_value == 25) enchantment=dec;
            $("#enchantment_value").html(enchantment+" ");
            set_stats(e_value);
            set_cstats();
            update_hash(e_value, ce_value);
            if (typeof real_item_prices !== 'undefined' && typeof real_item_prices['prices'] !== 'undefined') print_real_price(real_item_prices['prices']);
        }
    });
    $('.enh_minus').on("click", function ()
    {
        var ce_value=$("#cen_value").html();
        var e_value=$("#en_value").html();
        if (e_value > 0)
        {
            e_value --;
            if (e_value < 18)
            {
                $('.cenh_minus, .cenh_plus').prop('disabled', true);
            }
            $("#en_value").html(e_value);
            var enchantment="+"+e_value+': ';
            if (e_value == 16) enchantment=pri;
            else if (e_value == 17) enchantment=duo;
            else if (e_value == 18) enchantment=tri;
            else if (e_value == 19) enchantment=tet;
            else if (e_value == 20) enchantment=pen;
            else if (e_value == 21) enchantment=hex;
            else if (e_value == 22) enchantment=sep;
            else if (e_value == 23) enchantment=oct;
            else if (e_value == 24) enchantment=nov;
            else if (e_value == 25) enchantment=dec;
            $("#enchantment_value").html(enchantment+" ");
            if (e_value > 0) $("#enchantment_value").html(enchantment+" ");
            else $("#enchantment_value").html("");
            set_stats(e_value);
            set_cstats();
            update_hash(e_value, ce_value);
            if (typeof real_item_prices !== 'undefined' && typeof real_item_prices['prices'] !== 'undefined') print_real_price(real_item_prices['prices']);
        }
    });

    $('.cenh_plus').on("click", function ()
    {
        var e_value=$("#en_value").html();
        var ce_value=$("#cen_value").html();
        var max_enchant=$("#cen_value").data("maxenchant");
        if (ce_value < max_enchant)
        {
            ce_value ++;
            $("#cen_value").html(ce_value);
            set_cstats();
            update_hash(e_value, ce_value);
        }
    });
    $('.cenh_minus').on("click", function ()
    {
        var e_value=$("#en_value").html();
        var ce_value=$("#cen_value").html();
        if (ce_value > 0)
        {
            ce_value --;
            $("#cen_value").html(ce_value);
            set_cstats();
            update_hash(e_value, ce_value);
        }
    });

    $('.button_plus').on('click', function ()
    {
        var level=$('#worker_level').html();
        var max_enchant=$('#worker_level').data('max_level');
        if (level < max_enchant)
        {
            level ++;
            $('#worker_level').html(level);
            set_worker_stats(level);
        }
    });
    $('.button_minus').on('click', function ()
    {
        var level=$('#worker_level').html();
        var max_enchant=$('#worker_level').data('max_level');
        if (level > 0)
        {
            level --;
            $('#worker_level').html(level);
            set_worker_stats(level);
        }
    });

    add_price_handler();

    $("#craft_counter").keyup(function ()
    {
        var value=$(this).val();
        $(".counter_value").each(function ()
        {
            var parentquantity=$(this).parent().parent().parent().parent().children(".counter_value").html();
            var material_count=$(this).data("material");
            var product_count=$(this).data("product");

            //console.log($(this).parent().parent().parent().parent().children(".counter_value").html());
            //console.log(parentquantity);

            $(this).text(material_count * value);

            if (undefined != parentquantity && parentquantity.length > 0)
            {
                var multiplier=Math.ceil(parentquantity / product_count);
                $(this).text(material_count * multiplier);
            }
        });

        update_total_price();
    });
    $('#market_price').keyup(function ()
    {
        update_total_price();
    });

    $('#products_per_craft').keyup(function ()
    {
        update_total_price();
    });

    /*
        $("#craft_counter").keyup(function ()
        {
            $('#total_price').val(0 * 1);

            var value = $(this).val();
            $(".counter_value").each(function ()
            {
                var parentquantity = $(this).parent().parent().parent().parent().children(".counter_value").html();
                var material_count = $(this).data("material");
                var product_count = $(this).data("product");

                //console.log($(this).parent().parent().parent().parent().children(".counter_value").html());
                //console.log(parentquantity);

                $(this).text(material_count * value);

                if (undefined != parentquantity && parentquantity.length > 0)
                {
                    var multiplier = Math.ceil(parentquantity / product_count);
                    $(this).text(material_count * multiplier);
                }
            });

            // $(".material_price").each(function ()
            // 	{
            // 		calculate_price(this);
            // 	}
            // );
            update_total_price();
        });
    */

    set_toggle_event();

    $(".lv_minus,.lv_plus").on("click", function ()
    {
        if ($(this).data('type') == 'mount')
        {
            set_mount_data(this);
        }
        else if ($(this).data('type') == 'sailor')
        {
            set_sailor_data(this);
        }
        else set_pet_data(this);
    });

    if (get_action() == 'knowledge-old')
    {
        $(".theme_name").on("click", function ()
        {
            $(this).children('.en_plus, .en_minus').toggleClass('en_plus').toggleClass('en_minus');
            $(this).toggleClass('knowledge_highlight');
        });

        //$("#knowledge_filter").keyup(function ()
        //{
        //    filter_knowledge(this.value);
        //});

        $('#knowledge_filter').keyup(function ()
        {
            var query=this.value;
            delay(function ()
            {
                filter_knowledge(query);
            }, 500);
        });
        load_knowledge();
        add_knowledge_category_handlers();

        $('.knowledge_content').on('show.bs.collapse', function (e)
        {
            e.stopPropagation();
            //var subs = $(this).children('div').length;
            //var content = $('#' + e.currentTarget.id).html();
            $(this).find('.knowledge_category_mark_button').each(function ()
            {
                var tcid=$(this).data('tcid');
                if (tcid in sck)
                {
                    //$(this).addClass('active').find('.bi').removeClass('bi-square').addClass('bi-check-square');
                    $(this).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
                    $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
                }
            });

            var section=$('#base_'+e.currentTarget.id);
            var content=section.html();

            if (content != undefined && content.indexOf('|*lbr*|') >= 0)
//        if (content.indexOf('|*lbr*|') >= 0)
            {
                var data=content.replace(/\|\*lbr\*\|/g, '<').replace(/\|\*rbr\*\|/g, '>');
                section.html(data);
                $('#base_'+e.currentTarget.id+' .theme_entry').qtip(qtip_options());
                add_knowledge_buttons_handlers(section);

                $(section).find('.knowledge_mark_button').each(function ()
                {
                    var tid=$(this).data('tid');
                    if (tid in sk)
                    {
                        if (sk[tid] == 1 || (typeof sk[tid][0] !== 'undefined' && sk[tid][0] == 1))
                        {
                            //$(this).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
                            $(this).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
                            $('a[data-tid="'+tid+'"]').addClass('faded_kn');
                            $('span[data-tid="'+tid+'"]').addClass('faded_kn');
                        }
                        if (typeof sk[tid][1] !== 'undefined')
                        {
                            $(this).next().val(sk[tid][1]).change();
                        }
                    }
                });
            }

        });

        $("#reset_knowledge_tree").on("click", function ()
        {
            $('#knowledge_filter').val('');
            $('.en_minus').each(function ()
            {
                $(this).click();
            });
        });
    }


    get_hash();

    //$('#searchfield').focus();

    $('.show_all_languages').change(function ()
    {
        filter_comments(this);
    });
    $('#tax_checkbox').change(function ()
    {
        if ($(this).prop('checked'))
        {
            $('#tax_premium_checkbox').prop('checked', false);
            localStorage.setItem('tax_premium_checkbox', 0);
        }
        update_total_price();
        var value=$(this).prop('checked') ? 1 : 0;
        localStorage.setItem('tax_checkbox', value);
    });

    $('#tax_premium_checkbox').change(function ()
    {
        if ($(this).prop('checked'))
        {
            $('#tax_checkbox').prop('checked', false);
            localStorage.setItem('tax_checkbox', 0);
        }
        update_total_price();
        var value=$(this).prop('checked') ? 1 : 0;
        localStorage.setItem('tax_premium_checkbox', value);
    });

    $('#guaranteed_only').change(function ()
    {
        let state=$(this).prop('checked');

        $('.sub_materials').each(function ()
        {
            let product_type=$(this).data('pt')*1;
            if (product_type==2)
            {
                let content=$(this).find('.sub_materials_content').html();
                if (content.length<1)
                {
                    var recipe_id=$(this).data('id');
                    var recipe_type=$(this).data('type');
                    get_sub_materials(recipe_id, recipe_type, this);
                }
                if (state) $(this).addClass('hide_me');
                else $(this).removeClass('hide_me');
            }
        });
    });

    //load_ui_settings();

    if ($('#tax_checkbox').length > 0)
    {
        var tax_checkbox_state=localStorage.getItem('tax_checkbox');
        if (tax_checkbox_state !== null)
        {
            var value=(tax_checkbox_state * 1 === 1) ? true : false;
            $('#tax_checkbox').prop('checked', value);
        }
        var tax_premium_checkbox_state=localStorage.getItem('tax_premium_checkbox');
        if (tax_premium_checkbox_state !== null)
        {
            var value=(tax_premium_checkbox_state * 1 === 1) ? true : false;
            $('#tax_premium_checkbox').prop('checked', value);
        }
    }


    var prev_elevel=null;
    $('.enhancement_level').each(function ()
    {
        $(this).click(function (e)
        {
            e.stopPropagation();
        })
        .change(function ()
        {
            var selected_level=$(this).prop('selectedIndex') * 1;
            if (prev_elevel !== selected_level)
            {
                var stats_index=$(this).data('col');
                gear_table.data().each(function (d)
                {
                    //console.log(d);
                    var stats=JSON.parse(d[stats_index]);
//                    console.log('stats: ' + stats);
//                    console.log('length: ' + stats.length);
//                    console.log('selected_level: ' + selected_level);
//                    console.log(stats[stats.length - 1]);

                    var max_level=stats.length-1;
                    var level_stats;
                    if (selected_level > stats.length-1) level_stats=stats[stats.length-1];
                    else level_stats=stats[selected_level];

//                    console.log(level_stats);

                    var level_string=selected_level;
                    if (max_level < selected_level)
                    {
                        level_string=max_level;
                    }

                    var enchant_level=0;
                    if (level_string > - 1)
                    {
                        if (level_string == 16) enchant_level=pri;
                        else if (level_string == 17) enchant_level=duo;
                        else if (level_string == 18) enchant_level=tri;
                        else if (level_string == 19) enchant_level=tet;
                        else if (level_string == 20) enchant_level=pen;
                        else if (level_string == 21) enchant_level=hex;
                        else if (level_string == 22) enchant_level=sep;
                        else if (level_string == 23) enchant_level=oct;
                        else if (level_string == 24) enchant_level=nov;
                        else if (level_string == 25) enchant_level=dec;
                        else if (level_string == 0) enchant_level='';
                        else enchant_level='+'+level_string+':';

                        d[2]=d[2].replace(/data-enchant="[0-9]{1,2}"/, 'data-enchant="'+level_string+'"');
                        d[2]=d[2].replace(/<span>.*<\/span>/g, '<span>'+enchant_level+' </span>');
                    }
                    d[4]=level_stats['dm'];
                    d[5]=level_stats['df'];
                    d[6]=level_stats['ac'];
                    d[7]=level_stats['ev'];
                    d[8]=level_stats['dr'];
                    // console.log(stat_value);
                });
                gear_table.rows().invalidate();
                gear_table.order([[10, "desc"], [2, "asc"]]).draw();
                //gear_table.order([filter_index, 'desc']).draw();
                prev_elevel=selected_level;
            }
        });

    });

    get_real_price();

    // var tws = document.querySelector('#twitchjs');
    // if (typeof tws!=='undefined' && typeof init_twitch!=='undefined')
    // {
    //     tws.addEventListener('load', init_twitch());
    // }


    var tws=document.querySelector('#twitch-embed');
    if (typeof tws !== null && typeof init_twitch !== 'undefined')
    {
        var script=document.createElement('script');
        script.onload=function ()
        {
            init_twitch();
        };
        script.async=true;
        script.src='https://player.twitch.tv/js/embed/v1.js';

        //const subject = document.querySelector('body');
        //subject.insertAdjacentHTML("beforeend", script);
        document.body.appendChild(script);
    }

    if (get_action() == 'knowledge' || get_action() == 'knowledge2')
    {
        init_knowledge();
    }
    else if (get_action() == 'worldmap')
    {
        load_knowledge2();
    }


});

function init_knowledge()
{
    if (typeof categories !== 'undefined')
    {
        for (let idx in categories)
        {
            if (categories[idx][1] > 0)
            {
                let cat_id=idx * 1;
                if (typeof category_tree[categories[cat_id][1]] === 'undefined') category_tree[categories[cat_id][1]]=[];
                category_tree[categories[cat_id][1]].push(cat_id);
            }
        }
    }

    add_knowledge_pm_handler();
    add_knowledge_category_handler();
    $('#search_knowledge').on('click', function ()
    {
        filter_knowledge2($('#knowledge_filter').val());
    });

    $('#reset_knowledge_tree').on('click', function ()
    {
        $('#knowledge_filter').val('');
        $('#knowledge_search_results').html('');
    });

    $('#knowledge_filter').keyup(function (e)
    {
        // console.log(e.key);
        if (e.key == 'Enter')
        {
            filter_knowledge2($('#knowledge_filter').val());
        }
    });

    load_knowledge2();
}


function add_knowledge_pm_handler()
{
    $('.theme_name[data-state="0"]').each(function ()
    {
        $(this).on('click', function ()
        {
            $(this).children('.en_plus, .en_minus').toggleClass('en_plus').toggleClass('en_minus');
        });
        $(this).attr('data-state', 1);
    });
}

function add_knowledge_category_handler()
{
    $('.knowledge_content').on('show.bs.collapse', function (e)
    {
        e.stopPropagation();
        let state=$(this).attr('data-state') * 1;
        if (state == 0)
        {
            let content='';
            $(this).attr('data-state', 1);
            let parent_id=$(this).data('tcid') * 1;
            //$data_array[entry_tree] = array($row['main_theme'], $icon_id, format_description($row['npc_name']), $hint_id);
            //$categories['categories'][$row['id']] = array($row['theme_name'], $row['parent_id'], $row['cards_cnt'], $row['increase_wp_2'], $row['need_count_2'], $row['need_count'], $row['themes_cnt']);

            //Sub Categories
            if (typeof category_tree[parent_id] !== 'undefined')
            {
                //                    $points = mb_ereg_replace('{increaseWp}', $theme['increase_wp_2'], format_description($msg_array['ui_37_2269494245']));

                for (let idx in category_tree[parent_id])
                {
                    let cat_id=category_tree[parent_id][idx];
                    let points='';
                    if (categories[cat_id][3] > 0)
                    {
                        points=' '+kn_msgs[0].replace('{increaseWp}', categories[cat_id][3]);
                        if (categories[cat_id][4] > categories[cat_id][2]) categories[cat_id][4]=categories[cat_id][2];

                        if (categories[cat_id][6] == 0) points+=' | '+kn_msgs[1]+': '+categories[cat_id][4]+'/'+categories[cat_id][2];
                    }
                    let points_addon='';

                    let checkmark='square';
                    let selected_class='';
                    let active_class='';
                    if (typeof sck[cat_id] !== 'undefined' && sck[cat_id] == 1)
                    {
                        checkmark='check-square';
                        selected_class=' faded_kn';
                        active_class=' active';
                    }

                    content+='<div class="stretch knowledge_entry" data-tcid="'+cat_id+'"><span data-tcid="'+cat_id+'"><span class="pointer theme_name collapsed'+selected_class+'" data-state="0" data-bs-toggle="collapse" href="#theme_'+cat_id+'" aria-expanded="false" aria-controls="theme_'+cat_id+'" data-ep="0" data-tcid="'+cat_id+'"><div class="en_plus"></div> <b>'+categories[cat_id][0]+'</b>'+points+'</span>'+points_addon+'</span>';
                    content+=' <button class="btn btn-gradient btn-success btn-sm knowledge_category_mark_button'+active_class+'" type="button" data-tcid="'+cat_id+'" data-state="0"><svg class="bi" width="12" height="12" fill="white"><use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#'+checkmark+'"/></svg></button>';
                    content+='<div class="collapse knowledge_content" id="theme_'+cat_id+'" data-tcid="'+cat_id+'" data-state="0"></div>';
                    content+='</div>';
                }
            }
            //Entries
            if (typeof entry_tree[parent_id] !== 'undefined')
            {
                for (let idx in entry_tree[parent_id])
                {
                    content+=print_knowledge_entry(entry_tree[parent_id][idx]);
                }
            }
            $('#theme_'+parent_id).html(content);
            $('.theme_entry:not(data-hasqtip)').each(function ()
            {
                $(this).qtip(qtip_options());
            });
            add_knowledge_pm_handler();
            add_knowledge_category_handler();
            add_knowledge_mark_button_handler();
            add_knowledge_category_mark_button_handler();
        }
    });
}


function add_knowledge_mark_button_handler()
{
    $('.knowledge_mark_button[data-state="0"]').each(function ()
    {
        $(this).on('click', function ()
        {
            var tid=$(this).data('tid');
            $('.knowledge_mark_button[data-tid="'+tid+'"]').each(function ()
            {
                toggle_knowledge(this);
            });
        });
        $(this).attr('data-state', 1)
    });
    $('.knowledge_grade_selector[data-state="0"]').each(function ()
    {
        $(this).change(function ()
        {
            set_knowledge_grade(this);
        });
        $(this).attr('data-state', 1)
    });
}

function set_knowledge_grade(select_object)
{
    var tid=$(select_object).data('tid');
    var state=$(select_object).prev().hasClass('active') * 1;
    var grade=$(select_object).val();
    var idx=$(select_object).prop('selectedIndex');

    $(select_object)[0].className=$(select_object)[0][idx].className;
    $(select_object).addClass('knowledge_grade_selector');
    // console.log(tid);
    // console.log(state);
    if (typeof sk[tid] !== 'undefined' && typeof sk[tid][0] !== 'undefined') sk[tid][1]=[grade];
    sk[tid]=[state, grade];
    delay(function ()
    {
        save_knowledge();
    }, 1000);
}

function add_knowledge_category_mark_button_handler()
{
    $('.knowledge_category_mark_button[data-state="0"]').each(function ()
    {
        $(this).on('click', function ()
        {
            toggle_knowledge_category(this);
        });
        $(this).attr('data-state', 1)
    });
}

function toggle_knowledge_category(button_object)
{
    var tcid=$(button_object).data('tcid');
    if (typeof tcid != 'undefined')
    {
        if ($(button_object).hasClass('active'))
        {
            console.log('removing category '+tcid);
            toggle_knowledge_category_selection(button_object, tcid, 0);
            mark_knowledge_category_content(tcid, 0);
            delete sck[tcid];
        }
        else
        {
            console.log('adding category '+tcid);
            toggle_knowledge_category_selection(button_object, tcid, 1);
            mark_knowledge_category_content(tcid, 1);
            sck[tcid]=1;
        }
    }
    update_knowledge_counter2();
    delay(function ()
    {
        save_knowledge2();
    }, 1000);
}

function mark_knowledge_category_content(tcid, mark)
{
    for (let idx in category_tree[tcid])
    {
        let sub_tcid=category_tree[tcid][idx];
        if (mark) sck[sub_tcid]=1;
        else delete sck[sub_tcid];

        let button_object=$('.knowledge_category_mark_button[data-tid="'+sub_tcid+'"]');
        toggle_knowledge_category_selection(button_object, sub_tcid, mark);
        mark_knowledge_category_entires(sub_tcid, mark);
    }

    mark_knowledge_category_entires(tcid, mark);
}

function mark_knowledge_category_entires(tcid, mark)
{
    for (let idx in entry_tree[tcid])
    {
        let tid=entry_tree[tcid][idx];
        let button_object=$('.knowledge_mark_button[data-tid="'+tid+'"]');
        if (mark)
        {
            if (typeof sk[tid] !== 'undefined' && typeof sk[tid][0] !== 'undefined') sk[tid][0]=1;
            else sk[tid]=[1, 0];
            toggle_knowledge_selection(button_object, tid, 1);
        }
        else
        {
            toggle_knowledge_selection(button_object, tid, 0);
            delete sk[tid];
        }
    }
}


function toggle_knowledge_selection(button_object, tid, mark)
{
    if (mark)
    {
        $(button_object).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
        $('a[data-tid="'+tid+'"]').addClass('faded_kn');
    }
    else
    {
        $(button_object).removeClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#square"/>');
        $('a[data-tid="'+tid+'"]').removeClass('faded_kn');
    }

}

function toggle_knowledge_category_selection(button_object, tcid, mark)
{
    if (mark)
    {
        $(button_object).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
        $('.theme_name[data-tcid="'+tcid+'"]').addClass('faded_kn');
    }
    else
    {
        $(button_object).removeClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#square"/>');
        $('.theme_name[data-tcid="'+tcid+'"]').removeClass('faded_kn');
    }
}

function toggle_knowledge(button_object)
{
    var tid=$(button_object).data('tid');
    if (typeof tid != 'undefined')
    {
        var grade=$(button_object).next().val() * 1;
        if (grade == null || isNaN(grade)) grade=0;
        if ($(button_object).hasClass('active'))
        {
            // console.log('removing '+tid);
            toggle_knowledge_selection(button_object, tid, 0);
            $(button_object).next().val(0).change();
            delete sk[tid];
            //Если родительская категория была помечена - снять отметку.
            if (typeof sck[entries[tid][0]] !== 'undefined')
            {
                delete sck[entries[tid][0]];
                let sbutton_object=$('.knowledge_category_mark_button[data-tid="'+entries[tid][0]+'"]');
                toggle_knowledge_category_selection(sbutton_object, entries[tid][0], 0);
            }
        }
        else
        {
            // console.log('adding '+tid);
            toggle_knowledge_selection(button_object, tid, 1);
            if (typeof sk[tid] !== 'undefined' && typeof sk[tid][0] !== 'undefined') sk[tid][0]=1;
            sk[tid]=[1, grade];

            let parent_id=entries[tid][0];
            let marked=0;
            for (let idx in entry_tree[parent_id])
            {
                let sub_id=entry_tree[parent_id][idx];
                if (typeof sk[sub_id] !== 'undefined' && typeof sk[sub_id][0] !== 'undefined' && sk[sub_id][0] == 1) marked ++;
                else if (typeof sk[sub_id] !== 'undefined' && sk[sub_id] == 1) marked ++;
            }

            if (marked == categories[parent_id][2])
            {
                sck[parent_id]=1;
                let sbutton_object=$('.knowledge_category_mark_button[data-tid="'+parent_id+'"]');
                toggle_knowledge_category_selection(sbutton_object, parent_id, 1);
            }
        }

        update_knowledge_counter2();

        delay(function ()
        {
            save_knowledge2();
        }, 1000);
    }
}


function print_knowledge_entry(cat_id)
{
    //$datas[$row['id']] = array($row['theme_name'], $row['parent_id'], $row['cards_cnt'], $row['increase_wp_2'], $row['need_count_2'], $row['need_count'], $row['themes_cnt'], $row['gradeable']);
    let content='';
    let hint='';
    if (typeof hints[entries[cat_id][3]] !== 'undefined') hint=' ('+hints[entries[cat_id][3]]+')';

    let grade_selector='';
    let grades=['Grade', 'C', 'B', 'A', 'A+', 'S'];
    if (categories[entries[cat_id][0]][7] == 1 && entries[cat_id][0] != 15000) //exclude fish
    {
//        <option value="0" selected disabled>Grade</option>

        grade_selector='<select class="knowledge_grade_selector" data-tid="'+cat_id+'" data-state="0">';
        for (let i=0; i < grades.length; i ++)
        {
            let grade_selected='';
            if (typeof sk[cat_id] !== 'undefined' && typeof sk[cat_id][1] !== 'undefined' && sk[cat_id][1] == i)
            {
                grade_selected=' selected';
            }
            grade_selector+='<option class="knowledge_grade_'+i+'" value="'+i+'"'+grade_selected+'>'+grades[i]+'</option>';
        }
        grade_selector+='</select>';
    }

    let checkmark='square';
    let selected_class='';
    let active_class='';
    if (typeof sk[cat_id] !== 'undefined' && typeof sk[cat_id][0] !== 'undefined' && sk[cat_id][0] == 1)
    {
        checkmark='check-square';
        selected_class=' faded_kn';
        active_class=' active';
    }

    content+='<div><a href="/'+lang+'/theme/'+cat_id+'/" class="item_grade_0 theme_entry'+selected_class+'" data-tid="'+cat_id+'" data-id="theme--'+cat_id+'" target="_blank">'+
        '<img src="/items/'+icons[entries[cat_id][1]]+'" width="40px" height="40px" alt="icon">'+entries[cat_id][2]+hint+'</a>'+
        '<button class="btn btn-gradient btn-success btn-sm knowledge_mark_button ms-1'+active_class+'" type="button" data-tid="'+cat_id+'" data-state="0"><svg class="bi" width="12" height="12" fill="white"><use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#'+checkmark+'"/></svg></button> '+grade_selector+'</div>';

    return content;
}

function set_mount_data(button)
{
    var mount_level=$('#mount_level');
    var level=mount_level.html();
    var max_level=mount_level.data('max_level');

    if ($(button).data('action') == '-')
    {
        if (level > 1)
        {
            level --;
        }
    }
    else
    {
        if (level < max_level)
        {
            level ++;
        }
    }
    mount_level.html(level);
    $('#mount_exp').html(mount_data[level]['exp']);
    $('#mount_hp').html(mount_data[level]['hp']);
    $('#mount_stamina').html(mount_data[level]['stamina']);
    $('#mount_weight').html(mount_data[level]['weight']);
    $('#mount_speed').html(mount_data[level]['speed']);
    $('#mount_acceleration').html(mount_data[level]['acceleration']);
    $('#mount_cornering').html(mount_data[level]['cornering']);
    $('#mount_brake').html(mount_data[level]['brake']);
}

function set_sailor_data(button)
{
    var sailor_level=$('#sailor_level');
    var level=sailor_level.html() * 1;
    var max_level=sailor_level.data('max_level');

    if ($(button).data('action') == '-')
    {
        if (level > 1)
        {
            level --;
        }
    }
    else
    {
        if (level < max_level)
        {
            level ++;
        }
    }
    sailor_level.html(level);
    if (typeof sailor_data[level+1] === 'undefined') $('#exp').html('-');
    else $('#exp').html(sailor_data[level+1]['exp']);
    $('#hp').html(sailor_data[level]['hp']);
    $('#sta').html(sailor_data[level]['sta']);
    $('#wit').html(sailor_data[level]['wit']);
    $('#awa').html(sailor_data[level]['awa']);
    $('#arm').html(sailor_data[level]['arm']);
    $('#pat').html(sailor_data[level]['pat']);
    $('#str').html(sailor_data[level]['str']);
    $('#con').html(sailor_data[level]['con']);
    $('#view').html(sailor_data[level]['view']);
}

function set_pet_data(button)
{
    var pet_level=$('#pet_level');
    var level=pet_level.html();
    var max_level=pet_level.data('max_level');

    if ($(button).data('action') == '-')
    {
        if (level > 1)
        {
            level --;
        }
    }
    else
    {
        if (level < max_level)
        {
            level ++;
        }
    }
    pet_level.html(level);
    $('#skill_0').html(pet_skill_0[level]);
    $('#skill_1').html(pet_skill_1[level]);
    $('#pet_exp').html(pet_exp[level]);
}

function add_price_handler_old()
{
    $(".material_price").each(function ()
    {
        $(this).unbind('keyup');
        $(this).keyup(function ()
        {
            $(this).attr('data-price', $(this).val());
            $("#craft_counter").keyup();
        });
    });
}

function add_price_handler()
{
    $('.material_price').each(function ()
    {
        $(this).unbind('keyup');
        $(this).keyup(function ()
        {
            //console.log('keyup');
            var price=$(this).val();
            var item_id=$(this).data('item_id');
            var price_cell=$(this);
            delay(function ()
            {
                if (user_id > 1)
                {
                    save_price(item_id, price);
                }
                $(price_cell).attr('data-price', price);
                //$("#craft_counter").keyup();
                update_total_price();

            }, 500);
        });
    });

    $('.check_rid').each(function ()
    {
        $(this).unbind('change');
        $(this).change(function ()
        {
            update_total_price();
        });
    });
}


function calculate_price(selector)
{
    var parentquantity=$(selector).parent().parent().parent().children('.counter_value').text();
    if (undefined != parentquantity && parentquantity.length > 0)
    {
        // console.log('-------------------------------');
        var price=$(selector).attr('data-price');
        // console.log('material price:' + price);
        var selector_total_price=parentquantity * price;
        // console.log('material price x quantity:' + selector_total_price);
        if (selector_total_price != 0)
        {
            var total_price_cell=$('#total_price');
            // console.log('total price:' + total_price_cell.attr('data-price'));
            var new_total_price=total_price_cell.attr('data-price') * 1+selector_total_price;
            total_price_cell.attr('data-price', new_total_price);
            // console.log('total price after:' + total_price_cell.attr('data-price'));
            var total_price=total_price_cell.attr('data-price');

            var products_per_craft=$('#products_per_craft').val().replace(',', '.');
            if (products_per_craft > 0)
            {
                total_price=cut_number(total_price / products_per_craft, 1);
            }
            //$(total_price_cell).text(number_format(total_price, ',')).attr('data-price',total_price);
            $(total_price_cell).text(number_format(total_price, ','));
        }
    }
}


function calculate_price_old(selector)
{
    var parentquantity=$(selector).parent().parent().parent().children(".counter_value").html();
    if (undefined != parentquantity && parentquantity.length > 0)
    {
        var price=$(selector).attr('data-price');
        $(selector).attr('data-total_price', parentquantity * price);

        var total_price=$('#total_price');
        total_price.val(total_price.val() * 1+$(selector).attr('data-total_price') * 1);
    }

}

function qtip_options()
{
    return {
        show: {
            event: 'mouseenter'
        }, overwrite: false, style: {
            classes: 'qtip-transparent'
        }, content: {
            text: function (event, api)
            {
                var initial_text=$(this).attr(api.options.content.attr);
                if ($(this).data("ct"))
                {
                    tipstyle="comment_tip";
                    $(this).qtip("api").set("style.classes", tipstyle);
                }
                var object_id=$(this).attr('data-id');
                var quest_group=$(this).data("quest_group");
                if (object_id)
                {
                    //var tipstyle = "qtip-transparent";
                    //$(this).qtip("api").set("style.classes", tipstyle);
                    var tipid=object_id+$(this).data("quest_group")+$(this).data("spawn_id")+$(this).data("enchant")+lang;
                    if (tooltipCache[tipid])
                    {
                        return tooltipCache[tipid];
                    }

                    $.ajax({
                        url: "/tip.php", type: "GET", data: {
                            id: object_id,
                            quest_group: quest_group,
                            spawn_id: $(this).data("spawn_id"),
                            grade: $(this).data("grade"),
                            enchant: $(this).data("enchant"),
                            tiptype: $(this).data("tiptype"),
                            l: lang,
                            nf: "on"
                        }
                    })
                    .then(function (content)
                    {
                        tooltipCache[tipid]=content;
                        api.set("content.text", content);
                        // if (typeof quest_group !== 'undefined')
                        // {
                        //     if (quests_array==={}) get_quest_statuses();
                        //     $('.quest_status').each(function ()
                        //     {
                        //         set_quest_status(this);
                        //     });
                        // }
                    }, function (xhr, status, error)
                    {
                        // Upon failure... set the tooltip content to the status and error value
                        api.set("content.text", status+": "+error);
                    });
                    initial_text=initial_text ? initial_text+" (Loading...)" : "Loading...";
                }
                else
                {
                    var tipstyle="qtip-bootstrap";
                    $(this).qtip("api").set("style.classes", tipstyle);
                    $(this).qtip("api").set("position.adjust.x", 12);
                    $(this).qtip("api").set("position.adjust.y", 12);
                    $(this).qtip("api").set("style.tip.corner", false);
                }
                return initial_text;   // Set some initial text
            }
        }, position: {
            target: "mouse", effect: false, adjust: {
                method: "shift", x: 5, y: 5
            }, viewport: $(window)
        }, events: {
            hide: function (event, api)
            {
                var video=$(this).find('video').get(0);
                if (video !== undefined) video.pause();
            }, show: function (event, api)
            {
                var video=$(this).find('video').get(0);
                if (video !== undefined) video.play();
            }
        }
    };
};

function get_datatable(table_name, init_string, col_styles, col_icons, col_order)
{
    // var dtable = $("#" + table_name).DataTable({
    //     ajax: init_string,
    //     columns: JSON.parse(col_styles),
    //     order: JSON.parse(col_order),
    //     scrollCollapse: true,
    //     deferRender: true,
    //     responsive: true,
    //     stateSave: true,
    //     lengthMenu: [10, 25, 50, 100, 150, 200],
    //     pageLength: entries_per_page,
    //     "dom": '<<"inlinediv"l><"inlinediv column_shift column_select_button"B><"inlinediv float-end"f>><<"inlinediv"i><"inlinediv float-end"p>>rt<<"inlinediv"l><"inlinediv float-end"f>><<"mt-2"><<"inlinediv"i><"inlinediv float-end"p>>>',
    //     buttons: [{
    //         text: reset_settings_msg, action: function (e, dt, node, config)
    //         {
    //             dt.state.clear();
    //             window.location.reload();
    //         }
    //     }],
    //     language: {
    //         "url": "/lang/datatables_" + lang + ".txt", buttons: {
    //             colvis: colvis
    //         }
    //     },
    //     rowCallback: function (row, data, index)
    //     {
    //         customFnRowCallback(row, data, index, col_icons, dtable, table_name);
    //     },
    //     searchDelay: 350
    // })
    var paging_style="simple_numbers";
    var scrollx=false;
    // var responsive = true;
    if (is_mobile())
    {
        paging_style="simple";
        scrollx=true;
        responsive=false;
    }

    var dtable=$("#"+table_name).DataTable({
        ajax: {url: init_string, cache: true},
        columns: JSON.parse(col_styles),
        order: JSON.parse(col_order),
        // scrollCollapse: true,
        deferRender: true,
        scrollX: true,
        // responsive: responsive,
        autoWidth: true,
        pagingType: paging_style,
        stateSave: true,
        lengthMenu: [10, 25, 50, 100, 150, 200],
        pageLength: entries_per_page,
        "dom": '<<"inlinediv"l><"inlinediv ms-2 column_select_button"B><"inlinediv float-end"f>><<"inlinediv"i><"inlinediv float-end"p>>rt<<"inlinediv"l><"inlinediv float-end"f>><<"inlinediv"i><"inlinediv float-end"p>>',
        buttons: [{
            text: reset_settings_msg, action: function (e, dt, node, config)
            {
                dt.state.clear();
                window.location.reload();
                // dt.state.clear();
                // dt.order(JSON.parse(col_order)).draw();
            }
        }],
        language: {
            "url": "/lang/datatables_"+lang+".txt"
        },
        rowCallback: function (row, data, index)
        {
            customFnRowCallback(row, data, index, col_icons, dtable, table_name);
        },
        searchDelay: 350
    })
    .on("mouseenter", ".qtooltip", function (event)
    {
        $(this).qtip($.extend(true, qtip_options(), {show: {ready: true}}), event);
    })
    .on("click", "[data-group_id]", function (event)
    {
        $("#"+$(this).data("group_id")).toggle();
        $(this).children(".plus_minus").toggleClass("toggle-open");
    })
    .on("click", ".title_fav_checkbox", function (event)
    {
        //set_title_status(this);
        save_title_status(this);
    })
    .on("click", ".list_checkbox", function (event)
    {
        favorite_recipe(this, dtable);
    })
    .on("click", ".unsub_button", function (event)
    {
        unsubscribe(this);
    })
    .on('xhr.dt', function (e, settings, json, xhr)
    {
        if (json != null && favorites != null)
        {
            if (json.aaData.length > 0)
            {
                var action=get_action();
                if (action == 'recipes')
                {
                    for (var i=0, ien=json.aaData.length; i < ien; i ++)
                    {
                        if (json.aaData[i][0] in favorites && favorites[json.aaData[i][0]].state == 1)
                        {
                            json.aaData[i][12]=1;
                        }
                    }
                }
                // else if (action=='titles')
                // {
                //     for (var i = 0, ien = json.aaData.length; i < ien; i++)
                //     {
                //         var item_idx = $.inArray(json.aaData[i][0], titles_array);
                //         if (item_idx > -1)
                //         {
                //             json.aaData[i][11] = 1;
                //         }
                //     }
                // }
            }
        }
        // Note no return - manipulate the data directly in the JSON object.
    });

    // dtable.on( 'init', function ()
    // {
    //     console.log( 'Table Init' );
    // });
    // dtable.on( 'search', function ()
    // {
    //     console.log( 'Table search' );
    // });
    // dtable.on( 'draw', function ()
    // {
    //     console.log( 'Table draw finished' );
    // });

    var dsearch=$.fn.dataTable.util.throttle(function (val)
    {
        dtable.draw();
    }, 300);


    $('.dt_qfilter').keyup(function ()
    {
//        dtable.draw();
//        dsearch(this.value);
        var query=this.value;
        delay(function ()
        {
            dtable.draw();
        }, 500);
    });

    $('.dt_qfilter').change(function ()
    {
//        dtable.draw();
        var query=this.value;
        delay(function ()
        {
            dtable.draw();
        }, 500);

//        dsearch(this.value);
    });

    $('.material_icon').click(function ()
    {
        var state=$(this).attr('data-state');
        var item_id=$(this).data('item_id');
        state^=1;
        $(this).attr('data-state', state);
        $(this).toggleClass('effect_selected');
        if (state == 1)
        {
            //fade_effect(this, 1);
            filter_array.push(item_id);
        }
        else
        {
            //fade_effect(this, 0);
            var item_idx=$.inArray(item_id, filter_array);
            if (item_idx > - 1)
            {
                filter_array.splice(item_idx, 1);
            }
        }
        dtable.draw();
    });

    $('.product_effect').click(function ()
    {
        var state=$(this).attr('data-state');
        var effect_group_id=$(this).data('effect_group_id');
        state^=1;
        $(this).attr('data-state', state);
        $(this).toggleClass('effect_selected');
        if (state == 1)
        {
            //fade_effect(this, 1);
            effects_filter_array.push(effect_group_id);
        }
        else
        {
            //fade_effect(this, 0);
            var effect_idx=$.inArray(effect_group_id, effects_filter_array);
            if (effect_idx > - 1)
            {
                effects_filter_array.splice(effect_idx, 1);
            }
        }
        dtable.draw();
    });

    $('.gear_effect').click(function ()
    {
        var state=$(this).attr('data-state');
        var effect_group_id=$(this).data('effect_group_id');
        state^=1;
        $(this).attr('data-state', state);
        $(this).toggleClass('effect_selected');
        if (state == 1)
        {
            //fade_effect(this, 1);
            gear_effects_filter_array.push(effect_group_id);
        }
        else
        {
            //fade_effect(this, 0);
            var effect_idx=$.inArray(effect_group_id, gear_effects_filter_array);
            if (effect_idx > - 1)
            {
                gear_effects_filter_array.splice(effect_idx, 1);
            }
        }
        dtable.draw();
    });


    if ($('#'+table_name+'_min').length && $('#'+table_name+'_max').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var min_level=$('#'+settings.sTableId+'_min').val();
            var max_level=$('#'+settings.sTableId+'_max').val();
            var level_col=$('#'+settings.sTableId+'_min').data('col');
            var level=data[level_col] == "-" ? 0 : data[level_col] * 1;
            if (min_level == "" && max_level == "")
            {
                return true;
            }
            else if (min_level == "" && level <= max_level)
            {
                return true;
            }
            else if (min_level <= level && max_level == "")
            {
                return true;
            }
            else if (min_level <= level && level <= max_level)
            {
                return true;
            }
            return false;
        });
    }

    if ($('#'+table_name+'_class_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var classes_array=['_warrior', '_ranger', '_sorcerer', '_giant', '_tamer', '_blademaster', '_valkyrie', '_wizard', '_witch', '_ninja', '_blademasterwomen', '_kunoichi', '_darkelf', '_striker', '_mystic', '_lahn', '_archer', '_shai', '_guardian', '_hashashin', '_nova', '_sage', '_corsair', '_drakania', '_woosa', '_maegu', '_scholar', '_dosa', '_deadeye', '_wukong'];
            var class_value=JSON.parse(data[$('#'+settings.sTableId+'_warrior').data('col')]);

            var is_ok=false;
            var checked=false;
            if ($.inArray(255, class_value) > - 1 || class_value.length == 0)
            {
                is_ok=true;
            }
            else
            {
                for (var k=0; k < classes_array.length; k ++)
                {
                    var selector=$("#"+settings.sTableId+classes_array[k]);
                    if (selector.length && selector.is(":checked"))
                    {
                        checked=true;
                        var class_id=selector.data('class_id');
                        if ($.inArray(class_id, class_value) > - 1) is_ok=true;
                    }
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_equip_type_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var slots_array=['_all_gear', '_weapon', '_subweapon', '_awakening', '_helm', '_body', '_gloves', '_boots', '_costume'];
            var slot_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_weapon').data('col')]['sort_value']);
            for (var k=0; k < slots_array.length; k ++)
            {
                var selector=$("#"+settings.sTableId+slots_array[k]);
                if (selector.length && selector.is(":checked"))
                {
                    var slot_id=selector.data('slot_id');
                    if (slot_id == slot_value) return true;
                }
            }
            return false;
        });
    }

    if ($('#'+table_name+'_skill_type_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var slots_array=[1];
            var slot_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_skill_type_1').data('col')]);

            var is_ok=false;
            var checked=false;
            for (var k=0; k < slots_array.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_skill_type_'+slots_array[k]);
                if (selector.length && selector.is(":checked"))
                {
                    checked=true;
                    var skill_type=selector.data('skill_type');
                    if (skill_type == slot_value) is_ok=true;
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_misc_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var slots_array=[0, 1];
            var row_values=JSON.parse(sourceRow[$('#'+settings.sTableId+'_misc_filters').data('col')]);

            var is_ok=false;
            var checked=false;

            for (var k=0; k < slots_array.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_misc_'+slots_array[k]);
                if (selector.length && selector.is(":checked"))
                {
                    checked=true;
                    var filter_val=selector.data('misc_id') * 1;

                    if (row_values[filter_val] === 1) is_ok=true;
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }


    if ($('#'+table_name+'_search_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var object_types_array=[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
            var object_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_object_1').data('col')]['sort_value']);
            var is_ok=false;
            var checked=false;

            for (var k=0; k < object_types_array.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_object_'+object_types_array[k]);
                if (selector.length && selector.is(":checked"))
                {
                    checked=true;
                    var object_type_id=selector.data('object_id');
                    if (object_type_id == object_value) is_ok=true;
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_trade_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var object_value=sourceRow[$('#'+settings.sTableId+'_trade_skill').data('col')]['sort_value'];
            var is_ok=false;

            var selector=$("#"+settings.sTableId+'_trade_skill');
            if (selector.length)
            {
                var selector_val=selector.val();
                if (object_value <= selector_val) is_ok=true;
            }

            return is_ok;
        });
    }


    if ($('#'+table_name+'_quest_rewards_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var filters=['_exp', '_inventory', '_intimacy', '_skill_exp', '_skill_point', '_life_exp', '_enchantment', '_cp', '_gold'];
            var reward_types=JSON.parse(data[$('#'+settings.sTableId+'_exp').data('col')]);

            var is_ok=false;
            var checked=false;

            for (var k=0; k < filters.length; k ++)
            {
                var selector=$("#"+settings.sTableId+filters[k]);
                if (selector.length && selector.is(":checked"))
                {
                    checked=true;
                    var reward_type_id=selector.data('reward_type');
                    if ($.inArray(reward_type_id, reward_types) != - 1) is_ok=true;
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_quest_zone_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var filters=['_zone_0', '_zone_1', '_zone_2', '_zone_3', '_zone_4', '_zone_5', '_zone_6', '_zone_7', '_zone_8', '_zone_9', '_zone_10', '_zone_11', '_zone_12', '_zone_13', '_zone_14'];
            var zone_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_zone_0').data('col')]['sort_value']);

            var is_ok=false;
            var checked=false;

            for (var k=0; k < filters.length; k ++)
            {
                var selector=$("#"+settings.sTableId+filters[k]);
                if (selector.length && selector.is(":checked"))
                {
                    checked=true;
                    var zone_id=selector.data('zone');
                    if (zone_id == zone_value) is_ok=true;
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_gqreqs_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            if ($('#'+settings.sTableId+'_gqreqs_min').length && $('#'+settings.sTableId+'_gqreqs_max').length)
            {
                var min_level=$('#'+settings.sTableId+'_gqreqs_min').val();
                var max_level=$('#'+settings.sTableId+'_gqreqs_max').val();

                //var level_col = $('#' + settings.sTableId + '_gqreqs_min').data('col');

                var value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_gqreqs_min').data('col')]['sort_value']);

                var level=value == "-" ? 0 : value * 1;
                // console.log(level);
                // console.log(min_level);
                // console.log(max_level);

                if (min_level == "" && max_level == "")
                {
                    return true;
                }
                else if (min_level == "" && level <= max_level)
                {
                    return true;
                }
                else if (min_level <= level && max_level == "")
                {
                    return true;
                }
                else if (min_level <= level && level <= max_level)
                {
                    return true;
                }
                return false;
            }

            return true;
        });
    }

    if ($('#'+table_name+'_quests_skill_exp_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            if ($('#'+settings.sTableId+'_quests_skill_exp_min').length && $('#'+settings.sTableId+'_quests_skill_exp_max').length)
            {
                var min_level=$('#'+settings.sTableId+'_quests_skill_exp_min').val();
                var max_level=$('#'+settings.sTableId+'_quests_skill_exp_max').val();

                var level_col=$('#'+settings.sTableId+'_quests_skill_exp_min').data('col');

                var value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_quests_skill_exp_min').data('col')]['sort_value']);

                var level=value == "-" ? 0 : value * 1;

                if (min_level == "" && max_level == "")
                {
                    return true;
                }
                else if (min_level == "" && level <= max_level)
                {
                    return true;
                }
                else if (min_level <= level && max_level == "")
                {
                    return true;
                }
                else if (min_level <= level && level <= max_level)
                {
                    return true;
                }
                return false;
            }
            return true;
        });
    }

    if ($('#'+table_name+'_quests_exp_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            if ($('#'+settings.sTableId+'_quests_exp_min').length && $('#'+settings.sTableId+'_quests_exp_max').length)
            {
                var min_level=$('#'+settings.sTableId+'_quests_exp_min').val();
                var max_level=$('#'+settings.sTableId+'_quests_exp_max').val();

                var level_col=$('#'+settings.sTableId+'_quests_exp_min').data('col');

                var value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_quests_exp_min').data('col')]['sort_value']);

                var level=value == "-" ? 0 : value * 1;

                if (min_level == "" && max_level == "")
                {
                    return true;
                }
                else if (min_level == "" && level <= max_level)
                {
                    return true;
                }
                else if (min_level <= level && max_level == "")
                {
                    return true;
                }
                else if (min_level <= level && level <= max_level)
                {
                    return true;
                }
                return false;
            }
            return true;
        });
    }

    if ($('#'+table_name+'_quest_type_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var filters=['_type_0', '_type_1', '_type_2', '_type_3', '_type_4', '_type_5'];
            var type_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_type_0').data('col')]);

            var is_ok=false;
            var checked=false;

            for (var k=0; k < filters.length; k ++)
            {
                var selector=$("#"+settings.sTableId+filters[k]);
                if (selector.length && selector.is(":checked"))
                {
                    checked=true;
                    var type_id=selector.data('type');
                    if (type_id == type_value) is_ok=true;
                }
            }
            if (checked === false) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_gatherable_type_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var filters=['_gatherable_type_2', '_gatherable_type_4', '_gatherable_type_6', '_gatherable_type_7'];
            var zone_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_gatherable_type_2').data('col')]['sort_value']);

            var is_ok=true;
            for (var k=0; k < filters.length; k ++)
            {
                var selector=$("#"+settings.sTableId+filters[k]);
                if (selector.length && selector.is(":checked"))
                {
                    var zone_id=selector.data('gatherable_type');
                    if (zone_id != zone_value) is_ok=false;
                }
            }
            return is_ok;
        });
    }


    if ($('#'+table_name+'_grade_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var grade_array=[0, 1, 2, 3, 4, 5];
            var grade_value=JSON.parse(data[$('#'+settings.sTableId+'_grade_0').data('col')]);

            var is_ok=false;
            var show_all=true;
            for (var k=0; k < grade_array.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_grade_'+grade_array[k]);
                if (selector.length && selector.is(":checked"))
                {
                    show_all=false;
                    var grade_id=selector.data('grade_id');
                    if (grade_id == grade_value) is_ok=true;
                }
            }
            if (show_all) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_fish_category').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var category_array=[0, 1, 2, 3, 4];
            var category_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_fish_category_0').data('col')]['sort_value']);

            var is_ok=false;
            var show_all=true;
            for (var k=0; k < category_array.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_fish_category_'+category_array[k]);
                if (selector.length && selector.is(":checked"))
                {
                    show_all=false;
                    var category_id=selector.data('category');
                    if (category_id == category_value) is_ok=true;
                }
            }
            if (show_all) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_material_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var materials_value=JSON.parse(data[9]);
            var is_ok=true;
            if (filter_array.length != 'undefined')
            {
                //console.log(filter_array.length);
                for (var k=0; k < filter_array.length; k ++)
                {
                    //console.log('looking for: ' + filter_array[k]);
                    if ($.inArray(filter_array[k], materials_value) == - 1) is_ok=false;
                }
            }
            return is_ok;
        });
    }

    if ($('#'+table_name+'_gear_effect_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var filter_cell=$('#'+settings.sTableId+'_gear_effect_filters');
            if (filter_cell.length)
            {
                var col=filter_cell.data('col');
                var effects_value=JSON.parse(data[col]);
                var is_ok=true;
                if (gear_effects_filter_array.length != 'undefined')
                {
                    //console.log(effects_filter_array.length);
                    for (var k=0; k < gear_effects_filter_array.length; k ++)
                    {
                        //console.log('looking for: ' + effects_filter_array[k]);
                        if ($.inArray(gear_effects_filter_array[k], effects_value) == - 1) is_ok=false;
                    }
                }
                return is_ok;
            }
            return true;
        });
    }

    if ($('#'+table_name+'_product_effect_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var effects_value=JSON.parse(data[10]);
            var is_ok=true;
            if (effects_filter_array.length != 'undefined')
            {
                //console.log(effects_filter_array.length);
                for (var k=0; k < effects_filter_array.length; k ++)
                {
                    //console.log('looking for: ' + effects_filter_array[k]);
                    if ($.inArray(effects_filter_array[k], effects_value) == - 1) is_ok=false;
                }
            }
            return is_ok;
        });
    }

    if (sdte == 1)
    {
        $.fn.dataTable.ext.errMode='none';
    }

    if ($('#'+table_name+'_gems_effects_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var filter_cell=$('#'+settings.sTableId+'_gems_effects_filters');
            var col=filter_cell.data('col') * 1;
            var effects_value=JSON.parse(data[col]);
            var is_ok=true;
            if (typeof effects_filter_array.length !== 'undefined')
            {
                //console.log(effects_filter_array.length);
                for (var k=0; k < effects_filter_array.length; k ++)
                {
                    //console.log('looking for: ' + effects_filter_array[k]);
                    if ($.inArray(effects_filter_array[k], effects_value) == - 1) is_ok=false;
                }
            }
            return is_ok;
        });
    }

    if ($('#'+table_name+'_lightstones_effects_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var filter_cell=$('#'+settings.sTableId+'_lightstones_effects_filters');
            var col=filter_cell.data('col') * 1;
            var effects_value=JSON.parse(data[col]);
            var is_ok=true;
            if (typeof effects_filter_array.length !== 'undefined')
            {
                //console.log(effects_filter_array.length);
                for (var k=0; k < effects_filter_array.length; k ++)
                {
                    //console.log('looking for: ' + effects_filter_array[k]);
                    if ($.inArray(effects_filter_array[k], effects_value) == - 1) is_ok=false;
                }
            }
            return is_ok;
        });
    }

    if ($('#'+table_name+'_furniture_effects_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var effects_value=JSON.parse(data[5]);
            // console.log(effects_value);
            var is_ok=true;
            if (effects_filter_array.length != 'undefined')
            {
                //console.log(effects_filter_array.length);
                for (var k=0; k < effects_filter_array.length; k ++)
                {
                    // console.log('looking for: ' + effects_filter_array[k]);
                    if ($.inArray(effects_filter_array[k], effects_value) == - 1) is_ok=false;
                }
            }
            return is_ok;
        });
    }

    if ($('#'+table_name+'_consumables_effects_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex)
        {
            var effects_value=JSON.parse(data[4]);
            var is_ok=true;
            if (effects_filter_array.length != 'undefined')
            {
                //console.log(effects_filter_array.length);
                for (var k=0; k < effects_filter_array.length; k ++)
                {
                    //console.log('looking for: ' + effects_filter_array[k]);
                    if ($.inArray(effects_filter_array[k], effects_value) == - 1) is_ok=false;
                }
            }
            return is_ok;
        });
    }

    if ($('#'+table_name+'_craft_level_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var craft_levels=[0, 1, 2, 3, 4, 5, 6];
            var craft_level_value=JSON.parse(sourceRow[$('#'+settings.sTableId+'_craft_level_0').data('col')]['sort_value']);
            for (var k=0; k < craft_levels.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_craft_level_'+craft_levels[k]);
                if (selector.length && !selector.is(":checked"))
                {
                    var craft_level_id=selector.data('level');
                    if (craft_level_value > craft_level_id-10 && craft_level_value <= craft_level_id) return false;
                }
            }
            return true;
        });
    }

    if ($('#'+table_name+'_titles_types_filters').length)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var title_types=[1, 2];
            var title_id=JSON.parse(sourceRow[0]);
            var is_ok=false;
            var show_all=true;
            for (var k=0; k < title_types.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_title_type_'+title_types[k]);
                if (selector.length && selector.is(":checked"))
                {
                    show_all=false;
                    if (title_types[k] == 1 && $.inArray(title_id, titles_array) != - 1) is_ok=true;
                    else if (title_types[k] == 2 && $.inArray(title_id, titles_array) == - 1) is_ok=true;
                }
            }
            if (show_all) is_ok=true;
            return is_ok;
        });
    }

    if ($('#'+table_name+'_recipe_type_filters').length > 0)
    {
        $.fn.dataTable.ext.search.push(function (settings, data, dataIndex, sourceRow)
        {
            var recipe_types=[0, 1, 2, 3, 'fav'];
            var recipe_type_value=data[$('#'+settings.sTableId+'_recipe_type_0').data('col')];
            var fav_value=data[$('#'+settings.sTableId+'_recipe_type_fav').data('col')];

            var is_ok=false;
            var show_all=true;
            for (var k=0; k < recipe_types.length; k ++)
            {
                var selector=$("#"+settings.sTableId+'_recipe_type_'+recipe_types[k]);
                if (selector.length && selector.is(":checked"))
                {
                    show_all=false;
                    var recipe_type_id=selector.data('type');
                    if (recipe_types[k] == 'fav')
                    {
                        if (fav_value == recipe_type_id) is_ok=true;
                    }
                    else
                    {
                        if (recipe_type_value == recipe_type_id) is_ok=true;
                    }
                }
            }
            if (show_all) is_ok=true;
            return is_ok;
        });
    }


    return dtable;
}

function customFnRowCallback(row, data, displayIndex, col_icons, dtable, table_name)
{
    $.each(JSON.parse(col_icons), function (index, value)
    {
        if (data[value] !== "")
        {
            var cellValue=$("td:eq("+value+")", row).html();
            if (cellValue != null)
            {
                cellValue=cellValue.replace(/\[/g, "<");
                cellValue=cellValue.replace(/\]/g, ">");

                $("td:eq("+value+")", row).html(cellValue);
            }
        }
    });

    var action=get_action();

    if (action == 'recipes' && $(favorites).length > 0)
    {
        if ($('#'+table_name+'_recipe_type_filters').length > 0)
        {
            if (data[0] in favorites && favorites[data[0]].state == 1)
            {
                //console.log(dtable);
                dtable.cell($("td:eq(2)", row).parent().closest('tr'), 12).data(1);
                var cellValue=$("td:eq(2)", row).html();
                cellValue=cellValue.replace('name="fav_recipe_'+data[0]+'"', 'name="fav_recipe_'+data[0]+'" checked');
                $("td:eq(2)", row).html(cellValue);
            }
        }
    }
    else if (action == 'titles' && $(titles_array).length > 0)
    {
        var item_idx=$.inArray(data[0], titles_array);
        if (item_idx > - 1)
        {
            var cellValue=$("td:eq(2)", row).html();
            cellValue=cellValue.replace('name="fav_title_'+data[0]+'"', 'name="fav_title_'+data[0]+'" checked');
            $("td:eq(2)", row).html(cellValue);
        }
    }

    return row;
}


function get_sub_materials(recipe_id, recipe_type, object)
{
    $.ajax({
        url: "/ajax.php",
        dataType: "json",
        type: "GET",
        data: {a: "sub_material", recipe_id: recipe_id, recipe_type: recipe_type, l: lang}
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            //console.log($(object).data('id'));
            $(object).find('.sub_materials_content').html(content.data);
            // $(object).html(content.data);
            // $(object).children('.content').toggle();
            set_toggle_event();
            add_price_handler();
            set_price_button_handlers();
            get_real_material_prices(true);
        }
        else
        {
//                console.log(content.result + content.data);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}


function get_sub_materials_old(recipe_id, recipe_type, recipe_name, object)
{
    $.ajax({
        url: "/ajax.php",
        dataType: "json",
        type: "GET",
        data: {a: "sub_material", recipe_id: recipe_id, recipe_type: recipe_type, recipe_name: recipe_name, l: lang}
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            // $(object).html(content.data);
            // $(object).children(".content").toggle();
            $(object).find('.sub_materials_content').html(content.data);
            set_toggle_event();
            add_price_handler();
        }
        else
        {
//                console.log(content.result + content.data);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}

function set_stats(step)
{
    if (typeof enchantment_array !== 'undefined')
    {
        set_stat_value('damage', step);
        set_stat_value('defense', step);
        set_stat_value('evasion', step);
        set_stat_value('hevasion', step);
        set_stat_value('accuracy', step);
        set_stat_value('dreduction', step);
        set_stat_value('hdreduction', step);
        set_stat_value('durability', step);
        set_stat_value('description', step);
        set_stat_value('edescription', step);
        set_stat_value('enchant_item_counter', step);
        set_stat_value('enchant_chance', step);
        set_enchant_item('enchant_item', step);
        set_stat_value('pe_dura_dec', step);
        set_stat_value('fail_dura_dec', step);
        set_stat_value('cron_value', step);
        set_stat_value('cron_tvalue', step);
        set_pe_item('pe_item', step);
    }
}

function set_cstats()
{
    var caphras_line='';
    var caphras_count=0;
    var caphras_tcount=0;
    var sep='';
    var level=$('#en_value').html();
    var grade=$('#cen_value').html();
    if (typeof caphras_data !== 'undefined' && level >= 18)
    {
        if (typeof caphras_data[level][grade] !== 'undefined')
        {
            var evasion=0;
            var dr=0;
            var atk=0;
            for (var stat_id in caphras_data[level][grade]['stats'])
            {
                if (caphras_data[level][grade]['stats'][stat_id] > 0)
                {
                    var stat_value=caphras_data[level][grade]['stats'][stat_id];
                    if (stat_id == 'evasion' && typeof caphras_data[level][grade]['stats'][stat_id] != 'undefined' && typeof caphras_data[level][grade]['stats']['hevasion'] != 'undefined' && caphras_data[level][grade]['stats']['hevasion'] > 0)
                    {
                        stat_value=caphras_data[level][grade]['stats'][stat_id]+' (+'+caphras_data[level][grade]['stats']['hevasion']+')';
//						var ecell = $('#hevasion');
//						var evalue=ecell.data('value')*1+caphras_data[level][grade]['stats']['hevasion']*1;
//						ecell.html('(+'+evalue+')');
                    }
                    if (stat_id == 'defense' && typeof caphras_data[level][grade]['stats'][stat_id] != 'undefined' && typeof caphras_data[level][grade]['stats']['hdefense'] != 'undefined' && caphras_data[level][grade]['stats']['hdefense'] > 0)
                    {
                        stat_value=caphras_data[level][grade]['stats'][stat_id]+' (+'+caphras_data[level][grade]['stats']['hdefense']+')';
//						var hcell = $('#hdreduction');
//						var dvalue=hcell.data('value')*1+caphras_data[level][grade]['stats']['hdefense']*1;
//						hcell.html('(+'+dvalue+')');
                    }
                    if (stat_id != 'hevasion' && stat_id != 'hdefense')
                    {
                        if (stat_id == 'evasion')
                        {
                            evasion+=caphras_data[level][grade]['stats'][stat_id] * 1;
//							var cell = $('#evasion');
//							var value=cell.text()*1+caphras_data[level][grade]['stats'][stat_id]*1;
//							cell.html(value);
                        }
                        if (stat_id == 'defense')
                        {
                            dr+=caphras_data[level][grade]['stats'][stat_id] * 1;
//							var cell = $('#dreduction');
//							var value=cell.text()*1+caphras_data[level][grade]['stats'][stat_id]*1;
//							cell.html(value);
                        }
                        if (stat_id == 'damage')
                        {
                            atk+=caphras_data[level][grade]['stats'][stat_id] * 1;
                        }
                        caphras_line+=sep+caphras_data['stats_names'][stat_id]+': '+stat_value;
                        if (sep == '') sep='<br>';
                    }
                }
            }
            var adp=evasion+dr;
            var dpcell=$('#defense');
            dpcell.html(dpcell.attr('data-value') * 1+adp);
            var dmcell=$('#damage');
            var dvalues=dmcell.attr('data-value').split('~');
            dmcell.html((dvalues[0] * 1+atk)+' ~ '+(dvalues[1] * 1+atk));

            caphras_count=number_format(caphras_data[level][grade]['count'], ',');
            caphras_tcount=number_format(caphras_data[level][grade]['tcount'], ',');
        }
    }
    $('#caphras_enhancement_bonus').html(caphras_line);
    $('#caphras_value').html(caphras_count);
    $('#caphras_tvalue').html(caphras_tcount);
}

function set_cstats_old()
{
    var caphras_line='';
    var caphras_count=0;
    var caphras_tcount=0;
    var sep='';
    var level=$('#en_value').html();
    var grade=$('#cen_value').html();
    if (typeof caphras_data != 'undefined' && level >= 18)
    {
        if (caphras_data[level][grade] != undefined)
        {
            for (var stat_id in caphras_data[level][grade]['stats'])
            {
                if (caphras_data[level][grade]['stats'][stat_id] > 0)
                {
                    caphras_line+=sep+caphras_data['stats_names'][stat_id]+' '+caphras_data[level][grade]['stats'][stat_id];
                    if (sep == '') sep='<br>';
                }
            }
            caphras_count=number_format(caphras_data[level][grade]['count'], ',');
            caphras_tcount=number_format(caphras_data[level][grade]['tcount'], ',');
        }
    }
    $('#caphras_enhancement_bonus').html(caphras_line);
    $('#caphras_value').html(caphras_count);
    $('#caphras_tvalue').html(caphras_tcount);
}

function set_worker_stats(step)
{
    set_stat_value('work_speed', step);
    set_stat_value('move_speed', step);
    set_stat_value('luck', step);
    set_stat_value('nextlvexp', step);
    set_stat_value('sell_price', step);
    set_stat_value('upgrade_chance', step);
}


function set_stat_value(stat_selector, step)
{
    // console.log(stat_selector);
    // console.log(step);
    // console.log(enchantment_array);
    // console.log(enchantment_array[step]);
    // console.log(enchantment_array[step][stat_selector]);

    if (typeof enchantment_array[step][stat_selector] != 'undefined')
    {
        if (stat_selector == 'hevasion' || stat_selector == 'hdreduction')
        {
            var value='(+'+enchantment_array[step][stat_selector]+')';
            $('#'+stat_selector).html(value).attr('data-value', enchantment_array[step][stat_selector]);
        }
        else $('#'+stat_selector).html(enchantment_array[step][stat_selector]).attr('data-value', enchantment_array[step][stat_selector]);

        if (enchantment_array[step][stat_selector] != 0)
        {
            $('#'+stat_selector).parent().removeClass('hide_me').parent().removeClass('hide_me');
        }
    }
}

function set_enchant_item(stat_selector, step)
{
//    console.log(enchantment_array[step]);
    if (enchantment_array[step]["need_enchant_item_id"] > 0)
    {
        $('#enchant_item_block').removeClass('hide_me');

        var item_icon=enchantment_array[step]["need_enchant_item_icon"];
        item_icon=item_icon.replace(".dds", ".webp").toLowerCase();
        var item_data="<div class=\"iconset_wrapper_medium inlinediv\">"+"<a href=\"/"+lang+"/item/"+enchantment_array[step]["need_enchant_item_id"]+"/\" class=\"qtooltip\" data-id=\"item--"+enchantment_array[step]["need_enchant_item_id"]+"\" data-enchant=\"0\">"+"<div class=\"icon_wrapper\"><img src=\"/items/"+item_icon+"\" alt=\"icon\" class=\"list_icon_medium\"></div>"+"</a></div> - <a href=\"/"+lang+"/item/"+enchantment_array[step]["need_enchant_item_id"]+"/\" class=\"qtooltip item_grade_0\" data-id=\"item--"+enchantment_array[step]["need_enchant_item_id"]+"\">"+enchantment_array[step]["need_enchant_item_name"]+"</a>";

        $("#"+stat_selector).html(item_data);
        $(".qtooltip").each(function ()
        {
            $(this).qtip(qtip_options());
        });
    }
    else $('#enchant_item_block').addClass('hide_me');
}

function set_pe_item(stat_selector, step)
{
    if (enchantment_array[step]["pe_item_counter"] > 0)
    {
        $('#pe_block').removeClass('hide_me');
        $('#pe_dura_dec_block').removeClass('hide_me');

        var item_icon=enchantment_array[step]["need_enchant_item_icon"];
        item_icon=item_icon.replace(".dds", ".webp").toLowerCase();
        var item_data="<div class=\"iconset_wrapper_medium inlinediv\">"+"<a href=\"/"+lang+"/item/"+enchantment_array[step]["need_enchant_item_id"]+"/\" class=\"qtooltip\" data-id=\"item--"+enchantment_array[step]["need_enchant_item_id"]+"\" data-enchant=\"0\">"+"<div class=\"icon_wrapper\"><img src=\"/items/"+item_icon+"\" alt=\"icon\" class=\"list_icon_medium\"></div>"+"</a></div> - <a href=\"/"+lang+"/item/"+enchantment_array[step]["need_enchant_item_id"]+"/\" class=\"qtooltip item_grade_0\" data-id=\"item--"+enchantment_array[step]["need_enchant_item_id"]+"\">"+enchantment_array[step]["need_enchant_item_name"]+"</a>"+' x '+enchantment_array[step]["pe_item_counter"];

        $("#"+stat_selector).html(item_data);
        $(".qtooltip").each(function ()
        {
            $(this).qtip(qtip_options());
        });
    }
    else
    {
        //$('#pe_item_block').addClass('hide_me');
        $("#"+stat_selector).html(enchantment_array["na"]);
        $("#pe_dura_dec").html(0);
    }
}

function set_toggle_event_old()
{
    $(".toggle-image").each(function ()
    {
        $(this).unbind("click");
        $(this).click(function ()
        {
            $(this).siblings(".content").toggle();
            $(this).toggleClass("toggle-open");

            $(this).siblings().each(function ()
            {
                if ($(this).html().length < 5)
                {
                    var recipe_id=$(this).data("id");
                    var recipe_type=$(this).data("type");
                    var recipe_name=$(this).data("name");
                    get_sub_materials(recipe_id, recipe_type, recipe_name, $(this));
                }
            });
            $(this).siblings(".sub_materials").toggle();
        });
    });
    $(".qtooltip").each(function ()
    {
        $(this).qtip(qtip_options());
    });
    $("#craft_counter").keyup();

}

function set_toggle_event()
{
    $('.toggle-image').each(function ()
    {
        $(this).unbind("click");
        $(this).click(function ()
        {
            let show_random_recipes= $('#guaranteed_only').is(':checked');

            $(this).toggleClass('toggle-open');
            $(this).siblings('.sub_materials').each(function ()
            {
                let product_type=$(this).data('pt')*1;
                if (product_type==1 || show_random_recipes===false)
                {
                    let content=$(this).find('.sub_materials_content').html();
                    if (content.length<1)
                    {
                        var recipe_id=$(this).data('id');
                        var recipe_type=$(this).data('type');
                        get_sub_materials(recipe_id, recipe_type, this);
                    }
                    $(this).toggleClass('hide_me');
                }
            });
            //$(this).siblings('.sub_materials').toggle();
        });
    });
    $('.toggle .qtooltip').each(function ()
    {
        if (!$(this).data('qtip'))
        {
            $(this).qtip(qtip_options());
        }
    });
    $("#craft_counter").keyup();
}


function fadeout2()
{
    $(".test").hover(function ()
    {
        $(this).stop().animate({"opacity": "0.5"}, "fast");
//			$(this).stop().animate({"opacity": "1"}, "slow");
    }, function ()
    {
        $(this).stop().animate({"opacity": "1"}, "fast");
    });
}

function loading_handler()
{
    var loading=$('#loading');
    $(document)
    .ajaxStart(function ()
    {
        //$loading.show();
        loading.modal("show");
    })
    .ajaxStop(function ()
    {
        //$loading.hide();
        loading.modal("hide");
    });
}

function linktip()
{
    $('.comment_body a[href*="//bdocodex.com/"]').each(function ()
    {
        var link_array=this.pathname.replace(/(^\/|\/$)/g, '').split('/');

        if ($(link_array).length >= 3)
        {
            if (link_array[1] == 'item' || link_array[1] == 'npc' || link_array[1] == 'quest' || link_array[1] == 'recipe' || link_array[1] == 'design' || link_array[1] == 'title' || link_array[1] == 'theme' || link_array[1] == 'skill' || link_array[1] == 'buff' || link_array[1] == 'itemset' || link_array[1] == 'sskill' || link_array[1] == 'guildquest' || link_array[1] == 'house' || link_array[1] == 'pet' || link_array[1] == 'mount' || link_array[1] == 'article')
            {
                if (link_array[1] == 'quest' && 3 in link_array)
                {
                    $(this).attr('data-id', link_array[1]+'--'+link_array[3].replace(/[^0-9]/, ''))
                    $(this).attr('data-quest_group', link_array[2].replace(/[^0-9]/, ''))
                }
                else
                {
                    $(this).attr('data-id', link_array[1]+'--'+link_array[2].replace(/[^0-9]/, ''))
                }
                $(this).qtip(qtip_options());
            }
        }
    });
}

function fade_effect(selector, state)
{
    if (state == 1) $(selector).stop().animate({"opacity": "1"}, "fast");
    else if (state == - 1) $(selector).stop().animate({"opacity": "0.1"}, "fast");
    else $(selector).stop().animate({"opacity": "0.4"}, "fast");
}

function filter_knowledge2(query)
{
    // console.log(query);
    if (query.length >= 3)
    {
        let content='';
        for (let cat_id in entries)
        {
            let name=entries[cat_id][2];

            let subname='';

            if (typeof hints[entries[cat_id][3]] !== 'undefined') subname=hints[entries[cat_id][3]];

            if ((name != null && name.toLowerCase().search(query.toLowerCase()) > - 1) || (subname != null && subname.toLowerCase().search(query.toLowerCase()) > - 1) || (cat_id.toString().search(query.toLowerCase()) > - 1))
            {
                content+='<div class="mb-2">'
                if (typeof categories[entries[cat_id][0]] !== 'undefined')
                {
                    let path=[];
                    path.push(categories[entries[cat_id][0]][0]);
                    let parent_id=categories[entries[cat_id][0]][1];
                    while (parent_id != 0)
                    {
                        path.push(categories[parent_id][0]);
                        parent_id=categories[parent_id][1];
                    }
                    let path_line='';
                    let sep='';
                    for (let i=path.length; i > 0; i --)
                    {
                        path_line+=sep+path[i-1];
                        if (sep == '') sep=' / ';
                    }
                    content+='<div class="smallertext">'+path_line+'</div>';
                }
                content+=print_knowledge_entry(cat_id);
                content+='</div>';
            }
        }
        $('#knowledge_search_results').html(content);
        add_knowledge_mark_button_handler();
    }
}


function filter_knowledge(query)
{
    //query=query.toLowerCase();
//	 console.log(query);
    if (prev_query != query)
    {
        if (query.length >= 3)
        {
            $('.selected_line').each(function ()
            {
                $(this).removeClass('selected_line')
            });

            for (var ki in knowledge_array)
            {
                var name=knowledge_array[ki].name;
                var subname=knowledge_array[ki].subname;
                if ((name != null && name.toLowerCase().search(query.toLowerCase()) > - 1) || (subname != null && subname.toLowerCase().search(query.toLowerCase()) > - 1))
                {
                    var entry=$('[data-id="theme--'+knowledge_array[ki].id+'"]');
                    entry.addClass('selected_line');
                    //entry.parents('.knowledge_entry').children(':first-child .collapsed').click();
                    entry.parents('.knowledge_entry').children(':first-child').find('.collapsed').click();
                }
            }
        }
        prev_query=query;
    }
}

function save_price(item_id, item_price)
{
    $.post('/ajax.php', {
        a: 'save_price', item_id: item_id, item_price: item_price, l: lang, token: security_token
    })
    .done(function (data)
    {
        data=JSON.parse(data);
        if (data.result == 1)
        {
            // $("#popup_message").show("clip").delay(3000).hide("clip");
            //console.log('Price saved!');
        }
        else
        {
            alert(data.error);
        }
    });
}


var delay=(function ()
{
    var timer=0;
    return function (callback, ms)
    {
        clearTimeout(timer);
        timer=setTimeout(callback, ms);
    };
})();


function process_subscription(page_data)
{
    var sub_action=$(page_data).attr('data-action');
    $.ajax({
        url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
            a: "subscription",
            sub_a: sub_action,
            object_type_id: $(page_data).data('object_type_id'),
            object_id: $(page_data).data('object_id'),
            title: $(page_data).data('title'),
            token: security_token
        }
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            sub_action^=1;
            if (sub_action == 0)
            {
                $('#subscribe_button').html(subscribe_msg).removeClass('btn-default').addClass('btn-success');
            }
            else
            {
                $('#subscribe_button').html(unsubscribe_msg).removeClass('btn-success').addClass('btn-default');
            }
            $('#subscribe_button').attr('data-action', sub_action);
        }
        else
        {
            alert(content.error);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}

function favorite_recipe(page_data, dtable)
{
    var recipe_id=$(page_data).data('recipe_id');
    var state=0;
    if ($(page_data).children('input').is(":checked")) state=1;
    dtable.cell($(page_data).parent().closest('tr'), 12).data(state);

    $.ajax({
        url: "/ajax.php?l="+lang,
        dataType: "json",
        type: "POST",
        data: {a: "favorite", recipe_id: recipe_id, state: state, token: security_token}
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
        }
        else
        {
            alert(content.error);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}

function unsubscribe(page_data)
{
    var sub_id=$(page_data).attr('data-id');
    $.ajax({
        url: "/ajax.php?l="+lang,
        dataType: "json",
        type: "POST",
        data: {a: "unsubscribe", sub_id: sub_id, token: security_token}
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            $(page_data).closest('tr').remove();
        }
        else
        {
            alert(content.error);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}

function unsubscribe_all(page_data)
{
    $.ajax({
        url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {a: 'unsubscribe_all', token: security_token}
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            $('#'+$(page_data).data('name')).empty();
        }
        else
        {
            alert(content.error);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}


function save_user_settings()
{
    var enable_notification_checkbox=$('#enable_email_notification');
    var enable_notification=0;
    if (enable_notification_checkbox.length && enable_notification_checkbox.is(":checked")) enable_notification=1;

    var subscribe_by_default_checkbox=$('#subscribe_by_default');
    var subscribe_by_default=0;
    if (subscribe_by_default_checkbox.length && subscribe_by_default_checkbox.is(":checked")) subscribe_by_default=1;

    var show_en_titles_checkbox=$('#show_en_titles');
    var show_en_titles=0;
    if (show_en_titles_checkbox.length && show_en_titles_checkbox.is(":checked")) show_en_titles=1;
    var entries_per_page=$('#entries_per_page').val();

    $.ajax({
        url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
            a: "save_user_settings",
            enable_notification: enable_notification,
            subscribe_by_default: subscribe_by_default,
            entries_per_page: entries_per_page,
            show_en_titles: show_en_titles,
            token: security_token
        }
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            $("#popup_message").show("clip").delay(3000).hide("clip");
        }
        else
        {
            alert(content.error);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}


function get_hash()
{
    // var enchantment_array=$("#enchantment_array").html();
    if (typeof enchantment_array !== 'undefined')
    {
        if (typeof enchantment_array.max_enchant !== 'undefined')
        {
            var hash_array=window.location.hash.replace('#', '').split('|');
            let regex = /[^0-9\,]/gm;
            let subst = ``;
            let enchant_level = (typeof hash_array[0]!=='undefined') ? hash_array[0].replace(regex, subst) * 1: 0;
            let enchant_items = (typeof hash_array[1]!=='undefined') ? hash_array[1].replace(regex, subst) * 1: 0;
            let ce_level = (typeof hash_array[2]!=='undefined') ? hash_array[2].replace(regex, subst) * 1: 0;

            if (enchant_level > 0)
            {
                if (enchant_level <= enchantment_array.max_enchant)
                {
                    $("#en_value").html(enchant_level);

                    var enchantment="+"+enchant_level+':';
                    if (enchant_level == 16) enchantment=pri;
                    else if (enchant_level == 17) enchantment=duo;
                    else if (enchant_level == 18) enchantment=tri;
                    else if (enchant_level == 19) enchantment=tet;
                    else if (enchant_level == 20) enchantment=pen;
                    else if (enchant_level == 21) enchantment=hex;
                    else if (enchant_level == 22) enchantment=sep;
                    else if (enchant_level == 23) enchantment=oct;
                    else if (enchant_level == 24) enchantment=nov;
                    else if (enchant_level == 25) enchantment=dec;
                    $("#enchantment_value").html(enchantment+" ");
                    //$("#enchantment_value").html("+" + enchant_level + " ");
                    //window.location.hash = '#' + enchant_level + '|' + hash_array[1];
                    let hash_url='#'+enchant_level;
                    if (enchant_items!=0) hash_url+='|'+enchant_items;
                    if (ce_level>0)
                    {
                        if (enchant_items==0) hash_url+='|none';
                        hash_url+='|'+ce_level;
                    }

                    // window.history.replaceState({}, '', '#'+enchant_level+'|'+hash_array[1]+'|'+ce_level);
                    window.history.replaceState({}, '', hash_url);
                    var item_name=$('#item_name').text();
                    $('#bbcode').val('[url='+window.location.href+']'+item_name+'[/url]');
                    $('#htmllink').val('<a href="'+window.location.href+'">'+item_name+'</a>');

                    set_stats(enchant_level);
                    if (enchant_level >= 18)
                    {
                        $('.cenh_minus, .cenh_plus').prop('disabled', false);
                        set_cstats();
                    }
                }
                if (ce_level > 0)
                {
                    $("#cen_value").html(ce_level);
                    set_cstats();
                }
            }
            if (enchant_items!=0)
            {
                get_enchant_items(enchant_items);
            }
        }
    }
}

function get_enchant_items(items_string)
{
    $.ajax({
        url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {a: "enchant_items", data: items_string}
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            set_enchant_slots(content.data);
        }
        else
        {
//                console.log(content.result + content.data);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });

}

function set_enchant_slots(item_array)
{
    item_array=JSON.parse(item_array);
    for (var key in item_array)
    {
        var link='- <a href="/'+lang+'/item/'+item_array[key]['item_id']+'/" class="qtooltip item_grade_'+item_array[key]['item_grade']+'" data-id="item--'+item_array[key]['item_id']+'">'+item_array[key]['item_name']+'</a>';
        var socket_cell=$('.stone_socket[data-state="0"]').first();
        if (socket_cell.length)
        {
            socket_cell.attr('data-state', 1);
            socket_cell.html(link);
        }
    }

    $('.stone_socket[data-state="1"] .qtooltip').each(function ()
    {
        $(this).qtip(qtip_options());
    });

}

function update_hash(level, grade)
{
    var hash_array=window.location.hash.replace('#', '').split('|');

    let hash_value=level;
    if (typeof hash_array[1] !== 'undefined') hash_value+='|'+hash_array[1];
    if (grade>0)
    {
        if (typeof hash_array[1] === 'undefined') hash_value+='|none';
        hash_value+='|'+grade;
    }

    // if (hash_array[1] !== undefined) window.history.replaceState({}, '', '#'+level+'|'+hash_array[1]+'|'+grade);
    // else window.history.replaceState({}, '', '#'+level);
    window.history.replaceState({}, '', '#'+hash_value);

    var item_name=$('#item_name').text();
    $('#bbcode').val('[url='+window.location.href+']'+item_name+'[/url]');
    $('#htmllink').val('<a href="'+window.location.href+'">'+item_name+'</a>');
}

function save_ui_settings(filter_object)
{
    var object_name=$(filter_object).data('bs-target');
    var object_state=$(filter_object).attr('data-state');
    object_state^=1;
    var marker=(object_state ? 'up' : 'down');
    $(filter_object).find('.collapse_marker').html('<span class="collapse_marker"><svg class="bi" width="12" height="12" fill="white"><use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#caret-'+marker+'-fill"/></svg>');
    $(filter_object).attr('data-state', object_state);

    $.ajax({
        url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
            a: "update_ui_settings", name: object_name, state: object_state, token: security_token
        }
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
        }
        else
        {
            //alert(content.error);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });
}

function load_favorites()
{
    $.ajax({
        url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
            a: "load_favorites", token: security_token
        }
    })
    .then(function (content)
    {
        if (content.result == 1)
        {
            favorites=JSON.parse(content.data);
        }
    }, function (xhr, status, error)
    {
        console.log("STATUS: "+status+" ERROR: "+error);
    });
}


function update_total_price()
{
    $('#total_price').text(0).attr('data-price', 0 * 1);
    var multiset=false;
    if ($('.set_container').length) multiset=true;
    $('.material_price').each(function ()
    {
        var set_id=$(this).parents('.set_container').data('set_id');
        var set_checkbox_state=$('.check_set_id[data-set_id="'+set_id+'"]').prop('checked');
        if (!multiset || (multiset && set_checkbox_state))
        {
            // console.log('item: '+$(this).data('item_id'));
            var pid=$(this).data('item_id');
            var subrec_used=false;
            // console.log('Checkbox selector: '+'.check_rid[data-pid="' + pid + '"]');
            var subrecipes=$('.check_rid[data-pid="'+pid+'"]');
            subrecipes.each(function ()
            {
                // console.log('sub found: '+pid);
                if (subrecipes.prop('checked'))
                {
                    // console.log('sub checked');
                    subrec_used=true;
                }
            });

            if (!subrec_used)
            {
                // console.log('Subrec is not used');
                var rid=$(this).data('rid');
                var chkbox=$('.check_rid[data-rid="'+rid+'"]');
                // console.log('checkbox selector: .check_rid[data-rid="' + rid + '"]');
                if (chkbox.length > 0)
                {
                    // console.log('RID: ' + rid);
                    // console.log('checkbox found');
                    if (chkbox.prop('checked'))
                    {
                        // console.log('TP: '+$('#total_price').attr('data-price'));
                        calculate_price(this);
                    }
                }
                else calculate_price(this);
            }
        }
    });

    var recipe_id=$('#craft_counter').data('rid') * 1;
    var total_weight=0;
    $('.material_weight[data-rid="'+recipe_id+'"]').each(function ()
    {
        var counter=$(this).parent().parent().parent().find('.counter_value[data-rid="'+recipe_id+'"]').text() * 1;
        var weight=cut_number($(this).data('weight') * counter * 1, 2) * 1;
        $(this).text(weight+' LT');
        total_weight+=weight;
    });
    $('#total_weight').text(number_format(cut_number(total_weight, 2), ',')+' LT');

    var total_price=$('#total_price').attr('data-price') * 1;
//	console.log(total_price);
    var market_price=$('#market_price').val() * 1;
    if (typeof market_price === 'undefined') market_price=0;
    var tax_premium=$('#tax_premium_checkbox');
    var tax=$('#tax_checkbox');
    var tax_mul=1;
    var ppc=$('#products_per_craft').val().replace(',', '.');
    if (tax_premium.prop('checked')) tax_mul=0.845;
    if (tax.prop('checked')) tax_mul=0.65;
    //var price = (market_price * $('#craft_counter').val() * tax_mul - total_price) * ppc;
    var price=market_price * $('#craft_counter').val() * ppc * tax_mul-total_price;
    $('#profit').text(number_format(cut_number(price, 2), ','));
    if (price < 0) $('#profit').addClass('profit_border_negative');
    else $('#profit').removeClass('profit_border_negative');
}


/*
 function load_ui_settings(filter_object)
 {
 $.ajax(
 {
 url: "/ajax.php?l=" + lang,
 dataType: "json",
 type: "POST",
 data: {
 a: "load_ui_settings"
 }
 })
 .then(function (content)
 {
 if (content.result == 1)
 {
 update_ui(JSON.parse(content.data));
 }
 }, function (xhr, status, error)
 {
 console.log("STATUS: " + status + " ERROR: " + error);
 });
 }

 function update_ui(settings)
 {
 console.log(settings);
 for (var key in settings)
 {
 if (settings[key]['state']==0) $('.user_filter[data-target="'+settings[key]['object_name']+'"]').click();
 }
 }

 */

function cut_number(number, precision)
{
    var pos=String(number).indexOf('.');
    if (pos > 0)
    {
        if (precision > 0) number=String(number).substr(0, pos+precision+1);
        else number=String(number).substr(0, pos);
    }
    return number;
}

function number_format(number, separator)
{
    if (typeof separator === 'undefined') separator=',';
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}


function get_remaining_time_old(endtime, timezone)
{
    var hm=endtime.split(':');
    var cd=new Date();
    var year=cd.getFullYear();
    var month=cd.getMonth()+1;
    var day=cd.getDate();

    var hour=cd.getHours();
    var minute=cd.getMinutes();
    var sec=cd.getSeconds();

    var offset=cd.getTimezoneOffset() * 60000;

    var endtime=new Date(year+'-'+month+'-'+day+'T'+hm[0]+':'+hm[1]+':00'+timezone).getTime();
    var t=endtime-Date.parse(new Date());

    var seconds=Math.floor((t / 1000) % 60);
    var minutes=Math.floor((t / 1000 / 60) % 60);
    var hours=Math.floor((t / (1000 * 60 * 60)) % 24);
    var days=Math.floor(t / (1000 * 60 * 60 * 24));
    return {
        'total': t, 'days': days, 'hours': hours, 'minutes': minutes, 'seconds': seconds
    };
}

function get_remaining_time(endtime)
{
    var t=endtime-Date.parse(new Date());

    var seconds=Math.floor((t / 1000) % 60);
    var minutes=Math.floor((t / 1000 / 60) % 60);
    var hours=Math.floor((t / (1000 * 60 * 60)) % 24);
    var days=Math.floor(t / (1000 * 60 * 60 * 24));
    return {
        'total': t * 1, 'days': days, 'hours': hours, 'minutes': minutes, 'seconds': seconds
    };
}

function mark_boss_cell(row, cell)
{
    row=row+1;
    //$('#boss_timers_table tr').find(':nth-child(' + (cell+1) + ')').addClass('highlight');
    $('#boss_timers_table td').removeClass('current_boss');
    $('#boss_timers_table tr:eq('+row+') td:eq('+cell+')').addClass('current_boss');

}

function init_timer(id)
{
    var clock=$(id);
    var endtime=get_next_boss();

    function updateClock()
    {
        var t=get_remaining_time(endtime);
        var time_string='';
        if (t.days > 0) time_string+=t.days+' ';
        time_string+=('0'+t.hours).slice(- 2)+':'+('0'+t.minutes).slice(- 2)+':'+('0'+t.seconds).slice(- 2);

        clock.text(time_string);

//		console.log('ET'+endtime);
//		console.log(time_string);
//		console.log(t.total);
        if (t.total == timer_alert_period * 60000)
        {
            var play=false;
            var ids=$('.current_boss').data('id').toString().split(',');
            for (var key in ids)
            {
                if (boss_alerts[ids[key]] == 1) play=true;
            }

            if (play && timer_alert == 1)
            {
                var track=$('#sound_notification_1').val();
                if (track > 0)
                {
                    play_track(track);
                }
            }
            if (play && show_notifications == 1)
            {
                push_notification(timer_alert_period);
            }
        }
        if (t.total == timer_alert_period2 * 60000)
        {
            var play=false;
            var ids=$('.current_boss').data('id').toString().split(',');
            for (var key in ids)
            {
                if (boss_alerts[ids[key]] == 1) play=true;
            }

            if (play && timer_alert == 1)
            {
                var track=$('#sound_notification_2').val();
                if (track > 0)
                {
                    play_track(track);
                }
            }
            if (play && show_notifications == 1)
            {
                push_notification(timer_alert_period2);
            }
        }
        if (t.total == timer_alert_period3 * 60000)
        {
            var play=false;
            var ids=$('.current_boss').data('id').toString().split(',');
            for (var key in ids)
            {
                if (boss_alerts[ids[key]] == 1) play=true;
            }

            if (play && timer_alert == 1)
            {
                var track=$('#sound_notification_3').val();
                if (track > 0)
                {
                    play_track(track);
                }
            }
            if (play && show_notifications == 1)
            {
                push_notification(timer_alert_period3);
            }
        }
        if (t.total <= 0)
        {
            endtime=get_next_boss();
            t=get_remaining_time(endtime);
//			console.log('Update ET'+endtime);
//			console.log(t.total);
        }
    }

    updateClock();
    next_boss_timer=setInterval(updateClock, 1000);
}

function print_timers()
{
    var cd=new Date();
    var offset=cd.getTimezoneOffset() / 60 * - 1;
    var day=cd.getDay();
    if (day == 0) day=7;
    var zone=boss_spawns[boss_zone]['zone'];
//	console.log('CTZ:' + offset);
//	console.log('STZ:' + boss_spawns[boss_zone]['zone']);
    var diff=offset-boss_spawns[boss_zone]['zone'] * 1;
//	console.log('DIFF:' + diff);
    if (offset != boss_spawns[boss_zone]['zone'] && use_local_time == 1)
    {
        zone=offset;
    }

    //var table = '<table class="reward_table" id="boss_timers_table" border="1px" style="table-layout: fixed; width: 100%;">';
    var table='<table class="reward_table" id="boss_timers_table" border="1px" width="100%">';
    table+='<tr><th>'+days[0]+' UTC'+(zone < 0 ? "" : "+")+zone+'</th>';
    for (var d=1; d < 8; d ++)
    {
        table+='<th class="time_header">'+days[d]+'</th>';
    }
    table+='</tr>';
    for (var key in boss_spawns[boss_zone]['time'])
    {
        var spawn_time=key;
        if (diff != 0 && use_local_time == 1)
        {
            var tt=key.split(':');
            var ntt=tt[0] * 1+diff * 1;
            var addon='';
//			console.log('NT:' + ntt);
            //console.log(day);
            if (ntt < 0)
            {
                var new_day=day;
                if (new_day == 0) new_day=7;
                ntt=24+ntt;
                //addon = '<br>(' + msgs['pd'] + ')';
                addon='<br>('+days[new_day]+')';
            }
            else if (ntt >= 24)
            {
                ntt=ntt-24;
                var new_day=day+1;
                if (new_day == 8) new_day=1;
//				addon = '<br>(' + msgs['nd'] + ')';
                addon='<br>('+days[new_day]+')';
            }
            spawn_time=('0'+ntt).slice(- 2)+":"+tt[1]+addon;
        }
        table+='<tr><td class="time_cell">'+spawn_time+'</td>';
        for (var i=1; i < 8; i ++)
        {
            table+='<td data-id="'+boss_spawns[boss_zone]['time'][key][i]+'">'+get_npc_icon(boss_spawns[boss_zone]['time'][key][i], false)+'</td>';
        }
        table+='</tr>';
    }
    table+='</table>';
    $('#timer_table').fadeOut(100, function ()
    {
        $(this).html(table).fadeIn(500);
        $('#zone_tag').html(boss_zone.toUpperCase());
        init_timer('#timer');
    });
}

function get_npc_icon(data, icon)
{
    var npcs='';
    if (data != null)
    {
        var ids=data.split(',');
        var sep='';
        var isep='';
        for (var key in ids)
        {
            if (icon) npcs+='<div class="inlinediv'+isep+'"><img src="'+boss_data[ids[key]]['icon']+'" class="quest_icon" alt="icon"><div>'+boss_data[ids[key]]['name']+'</div></div>';
            else npcs+='<div class="item_grade_'+boss_data[ids[key]]['g']+'">'+sep+boss_data[ids[key]]['name']+'</div>';
            if (isep == '') isep=' column_shift';
            //if (sep == '') sep = '<hr class="tooltiphr">';
            //if (sep == '') sep = '<br>';
        }
    }
    return npcs;
}

function get_next_boss()
{
    var cd=new Date();
    var hour=cd.getHours();
    var cday=cd.getDate();
    var year=cd.getFullYear();
    var month=cd.getMonth()+1;
    var day=cd.getDay();
    var seconds=cd.getSeconds();
    if (day == 0) day=7;
    var minutes=cd.getMinutes();
    var offset=cd.getTimezoneOffset() * 60;
    var cur_spawn='';
    var cnt=0;
    var cur_time=hour * 3600+minutes * 60+seconds;
    var shift=0;
    var cell=0;

//	console.log(cd.getTimezoneOffset());

//	console.log('cur_time ' +cur_time);
//	console.log('zone ' +boss_spawns[boss_zone]['zone']*3600);
//	console.log('offset ' +offset);
    cur_time=cur_time+boss_spawns[boss_zone]['zone'] * 3600+offset;
//	console.log('cur_time ' +cur_time);
    if (cur_time > 24 * 3600)
    {
        cur_time=cur_time-24 * 3600;
        if (day == 7) day=1;
        else day ++;
        shift+=86400000;
    }
    if (cur_time < 0)
    {
        cur_time=24 * 3600-Math.abs(cur_time);
        if (day == 1) day=7;
        else day --;
        shift-=86400000;
    }
//	console.log('day ' +day);
//	console.log('spawn '+boss_spawns[boss_zone]['zone']*3600);
//	console.log('offset' + offset);
//	console.log('cur_time ' +cur_time);

    while (cnt < 20 && cur_spawn == '')
    {
        for (var key in boss_spawns[boss_zone]['time'])
        {
            var tt=key.split(':');

            var spawn_time=tt[0] * 3600+tt[1] * 60;

            if (spawn_time >= cur_time && boss_spawns[boss_zone]['time'][key][day] != null)
            {
                cur_spawn=key;
                break
            }
            cell ++;
        }
        if (cur_spawn == '')
        {
            if (day == 7) day=1;
            else day ++;
            cur_time=0;
            cell=0;
            shift+=86400000;
        }
        cnt ++;
    }

    var hm=cur_spawn.split(':');
    var timezone=boss_spawns[boss_zone]['zone'];
    if (timezone >= 0) timezone='+'+('0'+timezone).slice(- 2)+':00';
    else timezone='-'+('0'+Math.abs(timezone)).slice(- 2)+':00';

    var endtime=new Date(year+'-'+('0'+month).slice(- 2)+'-'+('0'+cday).slice(- 2)+'T'+hm[0]+':'+hm[1]+':00'+timezone).getTime()+shift;
    mark_boss_cell(cell, day);

    var current_boss=get_npc_icon(boss_spawns[boss_zone]['time'][cur_spawn][day], true);
    $('#timer_pane').html(current_boss);

    return endtime;
}

function set_cookie(name, value, days)
{
    if (days)
    {
        var date=new Date();
        date.setTime(date.getTime()+(days * 24 * 60 * 60 * 1000));
        var expires="; expires="+date.toGMTString();
    }
    else var expires="";
    document.cookie=name+"="+value+expires+"; path=/; SameSite=Strict";
}

function get_cookie(name)
{
    var nameEQ=name+"=";
    var ca=document.cookie.split(';');
    for (var i=0; i < ca.length; i ++)
    {
        var c=ca[i];
        while (c.charAt(0) == ' ') c=c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function init_boss_timers()
{
    $('.zone_button').each(function ()
    {
        $(this).click(function ()
        {
            boss_zone=$(this).data('zone');
            clearInterval(next_boss_timer);
            print_timers();
            set_cookie("bdo_boss_zone", boss_zone, 360);
        });
    });
    $('.play_sound').click(function ()
    {
        var track=$('#sound_notification_'+$(this).data('id')).val();
        if (track > 0)
        {
            play_track(track);
        }
    });

    $('.test_notification').click(function ()
    {
        push_notification(1);
    });

    $('#notification_volume').change(function ()
    {
//		console.log('here');
        var new_volume=$(this).val();
//		dingdong.volume = new_volume / 100;
//		loneranger.volume = new_volume / 100;
//		miracle.volume = new_volume / 100;
//		airattack.volume = new_volume / 100;
        Howler.volume(new_volume / 100);
        set_cookie("bdo_boss_timer_alert_volume", new_volume, 360);
    });

    var stored_zone=get_cookie("bdo_boss_zone");
    if (stored_zone !== null) boss_zone=stored_zone;
    update_notification_settings();

    $('.zone_button[data-zone="'+boss_zone+'"]').click();
}

function push_notification(alert_period)
{
    var ids=$('.current_boss').data('id').toString().split(',');
    var boss_names='';
    var sep='';
    for (var key in ids)
    {
        if (boss_alerts[ids[key]] == 1) boss_names+=sep+boss_data[ids[key]]['name'];
        if (sep == '') sep=' '+msgs['and']+' ';
    }

    var note='';
    if (ids.length > 1) note=msgs['ntp'].replace('%1', alert_period);
    else note=msgs['nt'].replace('%1', alert_period);
    note=note.replace('%2', boss_names);
    Push.create("BDO Codex Boss Timer", {
        body: note, timeout: 180000, onClick: function ()
        {
            this.close();
        }
    });
}

function update_notification_settings()
{
    var timer_alert_cookie=get_cookie("bdo_boss_timer_alert");
    if (timer_alert_cookie !== null) timer_alert=timer_alert_cookie * 1;
    else set_cookie("bdo_boss_timer_alert", timer_alert, 360);

    var timer_alert_period_cookie=get_cookie("bdo_boss_timer_alert_period");
    if (timer_alert_period_cookie !== null) timer_alert_period=timer_alert_period_cookie;
    else set_cookie("bdo_boss_timer_alert_period", timer_alert_period, 360);

    var timer_alert_period2_cookie=get_cookie("bdo_boss_timer_alert_period2");
    if (timer_alert_period2_cookie !== null) timer_alert_period2=timer_alert_period2_cookie;
    else set_cookie("bdo_boss_timer_alert_period2", timer_alert_period2, 360);

    var timer_alert_period3_cookie=get_cookie("bdo_boss_timer_alert_period3");
    if (timer_alert_period3_cookie !== null) timer_alert_period3=timer_alert_period3_cookie;
    else set_cookie("bdo_boss_timer_alert_period3", timer_alert_period3, 360);

    var use_local_time_cookie=get_cookie("bdo_boss_timer_local_time");
    if (use_local_time_cookie !== null) use_local_time=use_local_time_cookie * 1;
    else set_cookie("bdo_boss_timer_local_time", use_local_time, 360);

    var push_notification_cookie=get_cookie("bdo_boss_push_notification");
    if (push_notification_cookie !== null) show_notifications=push_notification_cookie * 1;
    else set_cookie("bdo_boss_push_notification", show_notifications, 360);

    for (var i=1; i < 4; i ++)
    {
        var track=get_cookie("timer_alert_track_"+i);
        if (track != null)
        {
            $('#sound_notification_'+i).val(track);
        }
    }


    $('#use_local_time').prop('checked', use_local_time ? 1 : 0);
    $('#show_notifications').prop('checked', show_notifications ? 1 : 0);
    $('#sound_notification').prop('checked', timer_alert ? 1 : 0);
    $('#timer_alert_period').val(timer_alert_period);
    $('#timer_alert_period2').val(timer_alert_period2);
    $('#timer_alert_period3').val(timer_alert_period3);

    var timer_alert_volume_cookie=get_cookie("bdo_boss_timer_alert_volume");
    if (timer_alert_volume_cookie !== null)
    {
        $('#notification_volume').val(timer_alert_volume_cookie * 1).trigger("change");
    }
    else set_cookie("bdo_boss_timer_alert_volume", $('#notification_volume').val(), 360);


    for (var key in boss_alerts)
    {
        var cookie_value=get_cookie("bdo_boss_alert_"+key);
        if (cookie_value !== null) boss_alerts[key]=cookie_value * 1;
        else set_cookie("bdo_boss_alert_"+key, boss_alerts[key], 360);
        $('.boss_selection[data-id="'+key+'"]').prop('checked', boss_alerts[key] ? 1 : 0);
    }

    $('#use_local_time').change(function ()
    {
        if ($(this).prop('checked')) use_local_time=1;
        else use_local_time=0;
        set_cookie("bdo_boss_timer_local_time", use_local_time, 360);
        $('.zone_button[data-zone="'+boss_zone+'"]').click();
    });

    $('#sound_notification').change(function ()
    {
        if ($(this).prop('checked')) timer_alert=1;
        else timer_alert=0;
        set_cookie("bdo_boss_timer_alert", timer_alert, 360);
    });

    $('#show_notifications').change(function ()
    {
        if ($(this).prop('checked')) show_notifications=1;
        else show_notifications=0;
        set_cookie("bdo_boss_push_notification", show_notifications, 360);
    });

    $('.boss_selection').change(function ()
    {
        var id=$(this).data('id') * 1;
        if ($(this).prop('checked')) boss_alerts[id]=1;
        else boss_alerts[id]=0;
        set_cookie("bdo_boss_alert_"+id, boss_alerts[id], 360);
    });

    $('#timer_alert_period').keyup(function ()
    {
        timer_alert_period=$(this).val();
        set_cookie("bdo_boss_timer_alert_period", timer_alert_period, 360);
    });
    $('#timer_alert_period2').keyup(function ()
    {
        timer_alert_period2=$(this).val();
        set_cookie("bdo_boss_timer_alert_period2", timer_alert_period2, 360);
    });
    $('#timer_alert_period3').keyup(function ()
    {
        timer_alert_period3=$(this).val();
        set_cookie("bdo_boss_timer_alert_period3", timer_alert_period3, 360);
    });

    for (var k=1; k < 4; k ++)
    {
        $('#sound_notification_'+k).change(function ()
        {
            var track=$(this).val() * 1;
            set_cookie("timer_alert_track_"+$(this).data('id'), track, 360);
        });
    }

}


function get_url_param(param_name)
{
    var url=new URL(window.location.href);
    return url.searchParams.get(param_name);
}


function play_track(track)
{
    alarms[track-1].play();
}

function play_track_old(track)
{
    var playPromise=alarms[track-1].play();
    playPromise.then(successFunction, failureFunction);

    function successFunction()
    {
        console.log('Playback finished.');
    }

    function failureFunction(err)
    {
        console.log('Playback failed. Retrying...');
        alarms[track-1].play();
    }

    /*
    if (playPromise !== undefined)
    {
        playPromise.then(function ()
        {

            // Automatic playback started!
        }).catch(function (error)
        {
            // Automatic playback failed.
            // Show a UI element to let the user manually start playback.
            alarms[track - 1].play();
        });
    }
    */
}

function add_knowledge_buttons_handlers(content)
{
//	if (get_action()=='knowledge')
//	{
    $(content).find('.knowledge_mark_button').each(function ()
    {
        $(this).off('click').click(function ()
        {
            toggle_theme(this);
        });
    });
    $('.knowledge_grade_selector').each(function ()
    {
        $(this).off('change').change(function ()
        {
            set_select_style($(this));
        });
    });
//	}
}

function add_knowledge_category_handlers()
{
    if (get_action() == 'knowledge')
    {
        $('.knowledge_category_mark_button').each(function ()
        {
            $(this).off('click').click(function ()
            {
                var tcid=$(this).data('tcid');
                var mark=1;
                if ($(this).hasClass('active')) mark=0;

                $('.knowledge_entry[data-tcid="'+tcid+'"]').find('.knowledge_mark_button, .knowledge_category_mark_button').each(function ()
                {
//					if ($(this).closest('.knowledge_entry').children(':first-child').hasClass('.collapsed'))
//					{
//
//					}
//					else
//					{
                    if (mark == 1) mark_theme(this);
                    else unmark_theme(this);
//					}
                });
            });
        });
    }
}


function toggle_theme(theme)
{
    var tid=$(theme).data('tid');
    if (typeof tid != 'undefined')
    {
        var grade=$(theme).next().val() * 1;
        if (grade == null || isNaN(grade)) grade=0;
        if ($(theme).hasClass('active'))
        {
            //console.log('removing '+tid);
            //$(theme).removeClass('active').find('i').removeClass('bi-check-square').addClass('bi-square');
            $(theme).removeClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#square"/>');
            $('a[data-tid="'+tid+'"]').removeClass('faded_kn');
            $(theme).next().val(0).change();
            delete sk[tid];
        }
        else
        {
            //console.log('adding '+tid);
            //$(theme).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
            $(theme).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
            $('a[data-tid="'+tid+'"]').addClass('faded_kn');
            if (typeof sk[tid] !== 'undefined' && typeof sk[tid][0] !== 'undefined') sk[tid][0]=1;
            sk[tid]=[1, grade];
        }
    }
    else
    {
        var tcid=$(theme).data('tcid');
        if ($(theme).hasClass('active'))
        {
            //console.log('removing '+tid);
            //$(theme).removeClass('active').find('i').removeClass('bi-check-square').addClass('bi-square');
            $(theme).removeClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#square"/>');
            $('span[data-tcid="'+tcid+'"]').removeClass('faded_kn');
            delete sck[tcid];
        }
        else
        {
            //console.log('adding '+tid);
            //$(theme).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
            $(theme).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
            $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
            sck[tcid]=1;
        }
    }
    delay(function ()
    {
        save_knowledge();
    }, 1000);
}

function mark_theme(theme)
{
    var tid=$(theme).data('tid');
    if (typeof tid != 'undefined')
    {
        var grade=$(theme).next().val() * 1;
        if (grade == null || isNaN(grade)) grade=0;
        //console.log('adding '+tid);
        //$(theme).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
        $(theme).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
        $('a[data-tid="'+tid+'"]').addClass('faded_kn');
        //$('span[data-tid="' + tid + '"]').addClass('faded');
        //sk[tid] = 1;
        if (typeof sk[tid] !== 'undefined' && typeof sk[tid][0] !== 'undefined') sk[tid][0]=1;
        sk[tid]=[1, grade];
    }
    else
    {
        var tcid=$(theme).data('tcid');
        //$(theme).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
        $(theme).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
        //$('a[data-tcid="' + tcid + '"]').addClass('faded');
        $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
        sck[tcid]=1;
    }

    delay(function ()
    {
        save_knowledge();
    }, 1000);
}

function unmark_theme(theme)
{
    var tid=$(theme).data('tid');
    if (typeof tid != 'undefined')
    {
        //console.log('removing '+tid);
        //$(theme).removeClass('active').find('i').removeClass('bi-check-square').addClass('bi-square');
        $(theme).removeClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#square"/>');
        $('a[data-tid="'+tid+'"]').removeClass('faded_kn');
        //$('span[data-tid="' + tid + '"]').removeClass('faded');
        delete sk[tid];
    }
    else
    {
        var tcid=$(theme).data('tcid');
        //$(theme).removeClass('active').find('i').removeClass('bi-check-square').addClass('bi-square');
        $(theme).removeClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#square"/>');
        //$('a[data-tcid="' + tcid + '"]').removeClass('faded');
        $('span[data-tcid="'+tcid+'"]').removeClass('faded_kn');
        delete sck[tcid];
    }

    delay(function ()
    {
        save_knowledge();
    }, 1000);
}

function save_knowledge()
{
    if (typeof user_id != 'undefined' && user_id > 1)
    {
        $.ajax({
            url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
                a: "save_user_knowledge", sk: JSON.stringify(sk), sck: JSON.stringify(sck), token: security_token
            }
        })
        .then(function (content)
        {
            if (content.result == 1)
            {
                // console.log(content.result);
                console.log('Saved to server!');
            }
            else
            {
                alert(content.error);
            }
        }, function (xhr, status, error)
        {
            console.log("STATUS: "+status+" ERROR: "+error);
        });
    }
    else
    {
        if (localStorage)
        {
            localStorage.setItem('MarkedThemes', JSON.stringify(sk));
            localStorage.setItem('MarkedThemeCategories', JSON.stringify(sck));
            console.log('Saved!');
        }
    }

    update_knowledge_counter();
}

function save_knowledge2()
{
    if (typeof user_id != 'undefined' && user_id > 1)
    {
        $.ajax({
            url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
                a: "save_user_knowledge", sk: JSON.stringify(sk), sck: JSON.stringify(sck), token: security_token
            }
        })
        .then(function (content)
        {
            if (content.result == 1)
            {
                // console.log(content.result);
                console.log('Saved to server!');
            }
            else
            {
                alert(content.error);
            }
        }, function (xhr, status, error)
        {
            console.log("STATUS: "+status+" ERROR: "+error);
        });
    }
    else
    {
        if (localStorage)
        {
            localStorage.setItem('MarkedThemes', JSON.stringify(sk));
            localStorage.setItem('MarkedThemeCategories', JSON.stringify(sck));
            console.log('Saved!');
        }
    }
}

function load_knowledge()
{
    if (get_action() == 'knowledge')
    {
        if (typeof user_id !== 'undefined' && user_id > 1)
        {
            $.ajax({
                url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
                    a: "load_user_knowledge", token: security_token
                }
            })
            .then(function (content)
            {
                if (content.result == 1)
                {
                    if (Object.keys(content.data).length > 0)
                    {
                        sk=JSON.parse(content.data.sk);
                        sck=JSON.parse(content.data.sck);
                    }
                    if (Object.keys(sk).length == 0)
                    {
                        if (localStorage)
                        {
                            if (localStorage.getItem('MarkedThemes') != null)
                            {
                                sk=JSON.parse(localStorage.getItem('MarkedThemes'));
                                for (var key in sk)
                                {
                                    if (typeof sk[key][0] === 'undefined')
                                    {
                                        sk[key]=[sk[key], 0];
                                    }
                                }
                            }
                            if (localStorage.getItem('MarkedThemeCategories') != null) sck=JSON.parse(localStorage.getItem('MarkedThemeCategories'));
                        }
                    }
                    $('.knowledge_category_mark_button').each(function ()
                    {
                        var tcid=$(this).data('tcid');
                        if (tcid in sck)
                        {
                            //$(this).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
                            $(this).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
                            $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
                        }
                    });
                    update_knowledge_counter();
                    console.log('Loaded from server!');
                }
            }, function (xhr, status, error)
            {
                console.log("STATUS: "+status+" ERROR: "+error);
            });
        }
        else
        {
            if (localStorage)
            {
                // if (localStorage.getItem('MarkedThemes') != null) sk = JSON.parse(localStorage.getItem('MarkedThemes'));
                if (localStorage.getItem('MarkedThemes') != null)
                {
                    sk=JSON.parse(localStorage.getItem('MarkedThemes'));
                    for (var key in sk)
                    {
                        if (typeof sk[key][0] === 'undefined')
                        {
                            sk[key]=[sk[key], 0];
                        }
                    }
                }
                if (localStorage.getItem('MarkedThemeCategories') != null) sck=JSON.parse(localStorage.getItem('MarkedThemeCategories'));
            }
        }
        $('.knowledge_category_mark_button').each(function ()
        {
            var tcid=$(this).data('tcid');
            if (tcid in sck)
            {
                //$(this).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
                $(this).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
                $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
            }
        });
        update_knowledge_counter();
    }
}

function load_knowledge2()
{
    if (typeof user_id !== 'undefined' && user_id > 1)
    {
        $.ajax({
            url: "/ajax.php?l="+lang, dataType: "json", type: "POST", data: {
                a: "load_user_knowledge", token: security_token
            }
        })
        .then(function (content)
        {
            if (content.result == 1)
            {
                if (Object.keys(content.data).length > 0)
                {
                    sk=JSON.parse(content.data.sk);
                    sck=JSON.parse(content.data.sck);
                }
                if (Object.keys(sk).length == 0)
                {
                    if (localStorage)
                    {
                        if (localStorage.getItem('MarkedThemes') != null)
                        {
                            sk=JSON.parse(localStorage.getItem('MarkedThemes'));
                            for (var key in sk)
                            {
                                if (typeof sk[key][0] === 'undefined')
                                {
                                    sk[key]=[sk[key], 0];
                                }
                            }
                        }
                        if (localStorage.getItem('MarkedThemeCategories') != null) sck=JSON.parse(localStorage.getItem('MarkedThemeCategories'));
                    }
                }
                $('.knowledge_category_mark_button').each(function ()
                {
                    var tcid=$(this).data('tcid');
                    if (tcid in sck)
                    {
                        //$(this).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
                        $(this).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
                        $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
                    }
                });
                update_knowledge_counter2();
                console.log('Loaded from server!');
            }
        }, function (xhr, status, error)
        {
            console.log("STATUS: "+status+" ERROR: "+error);
        });
    }
    else
    {
        if (localStorage)
        {
            // if (localStorage.getItem('MarkedThemes') != null) sk = JSON.parse(localStorage.getItem('MarkedThemes'));
            if (localStorage.getItem('MarkedThemes') != null)
            {
                sk=JSON.parse(localStorage.getItem('MarkedThemes'));
                for (var key in sk)
                {
                    if (typeof sk[key][0] === 'undefined')
                    {
                        sk[key]=[sk[key], 0];
                    }
                }
            }
            if (localStorage.getItem('MarkedThemeCategories') != null) sck=JSON.parse(localStorage.getItem('MarkedThemeCategories'));
        }
    }
    $('.knowledge_category_mark_button').each(function ()
    {
        var tcid=$(this).data('tcid');
        if (tcid in sck)
        {
            //$(this).addClass('active').find('i').removeClass('bi-square').addClass('bi-check-square');
            $(this).addClass('active').find('.bi').html('<use xlink:href="/bootstrap-icons/bootstrap-icons-custom.svg#check-square"/>');
            $('span[data-tcid="'+tcid+'"]').addClass('faded_kn');
        }
    });
    update_knowledge_counter2();
}

function update_knowledge_counter2()
{
    if (typeof entries !== 'undefined')
    {
        let obtained_knowledge=Object.keys(sk).length;
        $('#obtained_knowledge').html(obtained_knowledge);
        let total_knowledge=Object.keys(entries).length;
        $('#total_knowledge').html(number_format(total_knowledge));

        // console.log(total_knowledge);
        let percent=total_knowledge / 100;
        // console.log(percent);
        // console.log(obtained_knowledge);
        let obtained_percent=cut_number(obtained_knowledge / percent, 2);
        $('#obtained_knowledge_percent').html(obtained_percent);
    }
}

function update_knowledge_counter()
{
    var obtained_knowledge=Object.keys(sk).length;
    $('#obtained_knowledge').html(obtained_knowledge);
    var total_knowledge=$('.knowledge_mark_button').length;
    $('#total_knowledge').html(total_knowledge);

    var percent=total_knowledge / 100;
    var obtained_percent=cut_number(obtained_knowledge / percent, 2);
    $('#obtained_knowledge_percent').html(obtained_percent);
}

function get_action()
{
    var link_array=$(location).attr('href').replace(/(^\/|\/$)/g, '').split('/');
    if ($(link_array).length >= 4) return link_array[4];
    else return null;
}

function get_real_price()
{
    if (typeof real_item_prices !== 'undefined')
    {
        if (typeof real_item_prices['prices'] === 'undefined' && typeof real_item_prices['token'] !== 'undefined' && typeof real_item_prices['id'] !== 'undefined')
        {
            $.ajax({
                url: '/ajax.php',
                dataType: 'json',
                type: 'POST',
                data: {a: 'real_price', token: real_item_prices['token'], id: real_item_prices['id'], l: lang}
            })
            .then(function (content)
            {
                if (content.result == 1)
                {
                    real_item_prices['prices']=content.data;
                    print_real_price(content.data);
                }
                else
                {
                    //                console.log(content.result + content.data);
                }
            }, function (xhr, status, error)
            {
                console.log("STATUS: "+status+" ERROR: "+error);
            });
        }
        else print_real_price(real_item_prices['prices']);
    }
}


function print_real_price(prices)
{
    var enchant=0;
    if ($('#en_value').length > 0) enchant=$('#en_value').html() * 1;

    var content='<hr class="tooltiphr">'+ingame_price_msg+':<br>';
    for (var zone in prices)
    {
        if (typeof prices[zone][enchant] !== 'undefined') content+=zone+': '+number_format(prices[zone][enchant][0], ',')+' <span class="float-end">'+instock_msg+': '+prices[zone][enchant][1]+'</span>';
        else
        {
            //content+=zone+': '+number_format(prices[zone][0],',');
            while (enchant > 0 && typeof prices[zone][enchant] === 'undefined')
            {
                enchant --;
            }
            if (typeof prices[zone][enchant] !== 'undefined') content+=zone+': '+number_format(prices[zone][enchant][0], ',')+' <span class="float-end">'+instock_msg+': '+prices[zone][enchant][1]+'</span>';
        }
        content+='<br>';
    }
    $('#real_price').html(content);
}

function set_select_style(object)
{
    var tid=$(object).prev().data('tid');
    var state=$(object).prev().hasClass('active') * 1;
    var grade=$(object).val();
    var idx=$(object).prop('selectedIndex');

    $(object)[0].className=$(object)[0][idx].className;
    $(object).addClass('knowledge_grade_selector');
    // console.log(tid);
    // console.log(state);
    if (typeof sk[tid] !== 'undefined' && typeof sk[tid][0] !== 'undefined') sk[tid][1]=[grade];
    sk[tid]=[state, grade];
    delay(function ()
    {
        save_knowledge();
    }, 1000);
}

function is_mobile()
{
    // console.log(navigator.userAgent);
    return isMobile=(/android|ipad|iphone|ipod|samsung|webos|iemobile|opera mini|blackberry/i).test(navigator.userAgent);
}

function get_action()
{
    var parts=window.location.pathname.split('/');
    var action=(typeof parts[2] !== 'undefined') ? parts[2] : null;
    return action;
}

function copy_to_clipboard($text)
{
    let ret=navigator.clipboard.writeText($text);
}

function get_recipe_hash()
{
    var quantity=window.location.hash.replace('#', '');
    var regex=/[^0-9]/gm;
    var subst=``;
    var quantity=quantity.replace(regex, subst);
    if (quantity.length > 0) $('#craft_counter').val(quantity);
}

function set_recipe_hash_handler()
{
    $('#craft_counter').change(function ()
    {
        const quantity=$(this).val();
        if (quantity.length > 0) window.history.replaceState({}, '', '#'+quantity);
    });
}

function set_recipe_handler()
{
    $('.material_market_price').change(function ()
    {
        const item_id=$(this).data('item_id');
        const rid=$(this).data('rid');
        $('.material_price[data-rid="'+rid+'"][data-item_id="'+item_id+'"]').val($(this).val());
    });
    $('.product_market_price').change(function ()
    {
        $('#market_price').val($(this).val());
    });
}

function get_real_material_prices(force_update)
{
    if (typeof real_materials_prices !== 'undefined')
    {
        if (force_update || (typeof real_materials_prices['prices'] === 'undefined' && typeof real_materials_prices['token'] !== 'undefined'))
        {
            var materials_array=[];
            $('.material_market_price').each(function ()
            {
                if ($(this).attr('data-state') * 1 === 0) materials_array.push($(this).data('item_id') * 1);
            });
            $('.product_market_price').each(function ()
            {
                if ($(this).attr('data-state') * 1 === 0) materials_array.push($(this).data('item_id') * 1);
            });

            $.ajax({
                url: '/ajax.php',
                dataType: 'json',
                type: 'POST',
                data: {a: 'materials_prices', token: real_materials_prices['token'], materials: materials_array, l: lang}
            })
            .then(function (content)
            {
                if (content.result == 1)
                {
                    real_materials_prices['prices']=content.data;
                    update_real_material_prices();
                }
                else
                {
                    //                console.log(content.result + content.data);
                }
            }, function (xhr, status, error)
            {
                console.log("STATUS: "+status+" ERROR: "+error);
            });
        }
    }
}

function update_real_material_prices(force_update)
{
    if (typeof real_materials_prices['prices'] !== 'undefined')
    {
        for (var item_id in real_materials_prices['prices'])
        {
            var region=null;
            if (lang === 'ru') region='RU';
            else if (lang === 'id' || lang === 'seaen' || lang === 'th') region='SEA';
            else if (lang === 'jp') region='JP';
            else if (lang === 'kr') region='KR';
            else if (lang === 'sp' || lang === 'pt') region='SA';
            else if (lang === 'tr') region='MENA';
            else if (lang === 'cn') region='CN';
            else if (lang === 'tw') region='TW';
            else if (lang === 'de' || lang === 'es' || lang === 'fr' || lang === 'us')
            {
                var sregion=$('#price_region').val();
                if (sregion === 'NA') region='NA';
                else if (sregion === 'EU') region='EU';
                else if (sregion === 'NAC') region='NA Console';
                else if (sregion === 'EUC') region='EU Console';
                else region='NA';
            }
            else if (lang === 'gl') region='GL';
            var price=0;

            if (typeof real_materials_prices['prices'][item_id][region] !== 'undefined')
            {
                if (region !== null) price=real_materials_prices['prices'][item_id][region][0][0];
                var state=(force_update) ? '' : '[data-state="0"]';
                $('.material_market_price'+state+'[data-item_id="'+item_id+'"]').val(price).attr('data-state', 1);
                $('.product_market_price'+state+'[data-item_id="'+item_id+'"]').val(price).attr('data-state', 1);
            }
        }
    }

}

function set_price_button_handlers()
{
    $('.copy_real_price[data-state="0"]').each(function ()
    {
        $(this).click(function ()
        {
            var item_id=$(this).data('item_id');
            // $(this).prev('input').val($(this).next('input').val()).keyup();
            $('.price_field[data-item_id="'+item_id+'"]').val($('.product_market_price[data-item_id="'+item_id+'"], .material_market_price[data-item_id="'+item_id+'"]').val()).keyup();
        });
        $(this).attr('data-state', 1);
    });
    $('.copy_base_price[data-state="0"]').each(function ()
    {
        $(this).click(function ()
        {
//            $(this).prev('input').val($(this).prev('input').data('base-price')).keyup();
            var item_id=$(this).data('item_id');
            $('.price_field[data-item_id="'+item_id+'"]').val($('.price_field[data-item_id="'+item_id+'"]').data('base-price')).keyup();
            $(this).attr('data-state', 1);
        });
    });
}

function save_title_status(title)
{
    if (typeof localStorage !== 'undefined')
    {
        var title_id=$(title).data('title_id');

        var item_idx=$.inArray(title_id, titles_array);
        if (item_idx > - 1)
        {
            titles_array.splice(item_idx, 1);
        }
        else
        {
            titles_array.push(title_id);
            // $(title).prop('checked', true);
        }
        localStorage.setItem('titles_array', JSON.stringify(titles_array));
    }
}

function set_title_status(title)
{
    var title_id=$(title).data('title_id');
    if (title_id in titles_array) $(title).prop('checked', true);

}

function get_title_statuses()
{
    if (typeof localStorage !== 'undefined')
    {
        const stored=localStorage.getItem('titles_array');
        if (stored !== null)
        {
            var regex=/[^0-9\{\}\-:\,\"\]\[]/gm;
            var subst=``;
            var clean=stored.replace(regex, subst);
            titles_array=JSON.parse(clean);
        }
    }
}

function get_action()
{
    var parts=window.location.pathname.split('/');
    var action=(typeof parts[2] !== 'undefined') ? parts[2] : null;
    return action;
}


function add_search_handler()
{
    const search_form=document.getElementById('search_form');
    search_form.addEventListener('submit', function (e)
    {
        e.preventDefault();
        if (dropdown_idx > - 1)
        {
            window.open(search_results[dropdown_idx]['link']);
            dropdown_items[dropdown_idx].classList.toggle('search_dropdown_selected');
            dropdown_idx= - 1;
            return false;
        }
        else search_form.submit();
    });

    const search_field=document.getElementById('searchfield2');
    search_field.addEventListener('keydown', function (e)
    {
        // console.log(e.key);
        // console.log(e.keyCode);
        if (e.keyCode == 40) //down arrow
        {
            e.preventDefault();
            if (dropdown_idx > - 1) dropdown_items[dropdown_idx].classList.toggle('search_dropdown_selected');
            if (dropdown_idx < dropdown_items.length-1)
            {
                dropdown_idx ++;
            }
            else dropdown_idx=0;
            dropdown_items[dropdown_idx].classList.toggle('search_dropdown_selected');
            this.value=search_results[dropdown_idx]['name'];
        }
        else if (e.keyCode == 38) //up arrow
        {
            e.preventDefault();
            if (dropdown_idx > - 1) dropdown_items[dropdown_idx].classList.toggle('search_dropdown_selected');
            if (dropdown_idx == 0) dropdown_idx=dropdown_items.length-1;
            else dropdown_idx --;
            dropdown_items[dropdown_idx].classList.toggle('search_dropdown_selected');
            this.value=search_results[dropdown_idx]['name'];
        }
        else if (e.keyCode == 37 || e.keyCode == 39 || e.keyCode == 13) //left/right/enter
        {
        }
        else
        {
            delay(function ()
            {
                get_search_results();
            }, 250);
        }
    });
    search_field.addEventListener('focus', function (e)
    {
        // console.log('focus');
        show_search_dropdown();
    });
    search_field.addEventListener('click', function (e)
    {
        // console.log('click');
        show_search_dropdown();
    });

    document.addEventListener('click', (e) =>
    {
        if (!e.target.closest('.search_dropdown') && !e.target.closest('#searchfield2'))
        {
            const search_dropdown=document.getElementById('search_dropdown');
            search_dropdown.classList.remove('search_dropdown_show');
        }
    });
}

function show_search_dropdown()
{
    const search_dropdown=document.getElementById('search_dropdown');
    if (search_dropdown.innerHTML.length)
    {
        search_dropdown.classList.add('search_dropdown_show');
    }
}

async function get_search_results()
{
    const search_field=document.getElementById('searchfield2');
    let term=search_field.value.trim();
    if (term.length > 1 && term !== prev_sq)
    {
        prev_sq=term;
        const url='/ac.php?l=us&term='+term;
        try
        {
            const response=await fetch(url);
            if (!response.ok)
            {
                throw new Error(`Response status: ${response.status}`);
            }
            search_results=JSON.parse(await response.text());
            update_search_dropdown(search_results);
        }
        catch (error)
        {
            alert(`Error: ${error.message}`);
        }
    }
    if (term.length == 0)
    {
        search_results=[];
        update_search_dropdown(search_results);
    }

}

function update_search_dropdown(results)
{
    $('.search_dropdown .qtooltip').each(function ()
    {
        $(this).qtip('destroy', true);
    });

    const search_dropdown=document.getElementById('search_dropdown');
    let content='';
    for (let idx in results)
    {
        let item=results[idx];
        let quest_group=(typeof item['quest_group'] !== 'undefined') ? ' data-quest_group="'+item['quest_group']+'"' : '';
        let subicon=(typeof item['subicon'] !== 'undefined') ? item['subicon'] : '';

        // content+='<a href="'+item['link']+'" target="_blank" tabindex=0><div class="dropdown_item qtooltip" data-id="'+item['link_type']+'--'+item['value']+'"'+quest_group+'>'+
        //     '<div class="search_icon me-1"><img src="/'+item['icon_path']+'/'+item['icon']+'" class="image-text grade_frame_'+item['grade']+'" alt="icon" width="35px" height="35px">'+subicon+'</div> '+
        //     '<span class="item_grade_'+item['grade']+'">'+item['name']+'</span><span class="object_type">'+item['object_type']+'</span></div></a>';
        content+='<a href="'+item['link']+'" target="_blank" tabindex=0>' +
            '<div class="dropdown_item qtooltip" data-id="'+item['link_type']+'--'+item['value']+'"'+quest_group+'>'+
            '<div class="search_icon me-1"><img src="/'+item['icon_path']+'/'+item['icon']+'" class="image-text grade_frame_'+item['grade']+'" alt="icon" width="35px" height="35px">'+subicon+'</div> '+
            '<div class="item_grade_'+item['grade']+'">'+item['name']+'</div><div class="dropdown_item_type">'+item['object_type']+'</div>' +
            '</div></a>';
    }
    search_dropdown.innerHTML=content;
    if (content != '')
    {
        // search_dropdown.focus({focusVisible: false});
        search_dropdown.classList.add('search_dropdown_show');
        if (!is_mobile())
        {
            $('.search_dropdown .qtooltip').each(function ()
            {
                $(this).qtip(qtip_options());
            });
        }
        dropdown_items=Array.from(search_dropdown.children);
        // console.log(dropdown_items);
    }
    else search_dropdown.classList.remove('search_dropdown_show');

}
